export const getFoodChart = (t) => ({
    // standard food chart
    "VataPitta_1800": {
        "mdt": {
            "vp_1800_mdt_1": t("vp_1800_mdt_1"),
            "vp_1800_mdt_2": t("vp_1800_mdt_2"),
            "vp_1800_mdt_3": t("vp_1800_mdt_3"),
            "vp_1800_mdt_4": t("vp_1800_mdt_4"),
            "vp_1800_mdt_5": t("vp_1800_mdt_5"),
            "vp_1800_mdt_6": t("vp_1800_mdt_6"),
            "vp_1800_mdt_7": t("vp_1800_mdt_7")
        },
        "mbf": {
            "vp_1800_mbf_1": t("vp_1800_mbf_1"),
            "vp_1800_mbf_2": t("vp_1800_mbf_2"),
            "vp_1800_mbf_3": t("vp_1800_mbf_3"),
            "vp_1800_mbf_4": t("vp_1800_mbf_4"),
            "vp_1800_mbf_5": t("vp_1800_mbf_5"),
            "vp_1800_mbf_6": t("vp_1800_mbf_6"),
            "vp_1800_mbf_7": t("vp_1800_mbf_7")
        },
        "mmb": {
            "vp_1800_mmb_1": t("vp_1800_mmb_1"),
            "vp_1800_mmb_2": t("vp_1800_mmb_2"),
            "vp_1800_mmb_3": t("vp_1800_mmb_3"),
            "vp_1800_mmb_4": t("vp_1800_mmb_4"),
            "vp_1800_mmb_5": t("vp_1800_mmb_5"),
            "vp_1800_mmb_6": t("vp_1800_mmb_6"),
            "vp_1800_mmb_7": t("vp_1800_mmb_7")
        },
        "lunch": {
            "vp_1800_lunch_1": t("vp_1800_lunch_1"),
            "vp_1800_lunch_2": t("vp_1800_lunch_2"),
            "vp_1800_lunch_3": t("vp_1800_lunch_3"),
            "vp_1800_lunch_4": t("vp_1800_lunch_4"),
            "vp_1800_lunch_5": t("vp_1800_lunch_5"),
            "vp_1800_lunch_6": t("vp_1800_lunch_6"),
            "vp_1800_lunch_7": t("vp_1800_lunch_7")
        },
        "snack": {
            "vp_1800_snack_1": t("vp_1800_snack_1"),
            "vp_1800_snack_2": t("vp_1800_snack_2"),
            "vp_1800_snack_3": t("vp_1800_snack_3"),
            "vp_1800_snack_4": t("vp_1800_snack_4"),
            "vp_1800_snack_5": t("vp_1800_snack_5"),
            "vp_1800_snack_6": t("vp_1800_snack_6"),
            "vp_1800_snack_7": t("vp_1800_snack_7")
        },
        "dinner": {
            "vp_1800_dinner_1": t("vp_1800_dinner_1"),
            "vp_1800_dinner_2": t("vp_1800_dinner_2"),
            "vp_1800_dinner_3": t("vp_1800_dinner_3"),
            "vp_1800_dinner_4": t("vp_1800_dinner_4"),
            "vp_1800_dinner_5": t("vp_1800_dinner_5"),
            "vp_1800_dinner_6": t("vp_1800_dinner_6"),
            "vp_1800_dinner_7": t("vp_1800_dinner_7")
        }
    },
    "VataPitta_2000": {
        "mdt": {
            "vp_2000_mdt_1": t("vp_2000_mdt_1"),
            "vp_2000_mdt_2": t("vp_2000_mdt_2"),
            "vp_2000_mdt_3": t("vp_2000_mdt_3"),
            "vp_2000_mdt_4": t("vp_2000_mdt_4"),
            "vp_2000_mdt_5": t("vp_2000_mdt_5"),
            "vp_2000_mdt_6": t("vp_2000_mdt_6"),
            "vp_2000_mdt_7": t("vp_2000_mdt_7")
        },
        "mbf": {
            "vp_2000_mbf_1": t("vp_2000_mbf_1"),
            "vp_2000_mbf_2": t("vp_2000_mbf_2"),
            "vp_2000_mbf_3": t("vp_2000_mbf_3"),
            "vp_2000_mbf_4": t("vp_2000_mbf_4"),
            "vp_2000_mbf_5": t("vp_2000_mbf_5"),
            "vp_2000_mbf_6": t("vp_2000_mbf_6"),
            "vp_2000_mbf_7": t("vp_2000_mbf_7")
        },
        "mmb": {
            "vp_2000_mmb_1": t("vp_2000_mmb_1"),
            "vp_2000_mmb_2": t("vp_2000_mmb_2"),
            "vp_2000_mmb_3": t("vp_2000_mmb_3"),
            "vp_2000_mmb_4": t("vp_2000_mmb_4"),
            "vp_2000_mmb_5": t("vp_2000_mmb_5"),
            "vp_2000_mmb_6": t("vp_2000_mmb_6"),
            "vp_2000_mmb_7": t("vp_2000_mmb_7")
        },
        "lunch": {
            "vp_2000_lunch_1": t("vp_2000_lunch_1"),
            "vp_2000_lunch_2": t("vp_2000_lunch_2"),
            "vp_2000_lunch_3": t("vp_2000_lunch_3"),
            "vp_2000_lunch_4": t("vp_2000_lunch_4"),
            "vp_2000_lunch_5": t("vp_2000_lunch_5"),
            "vp_2000_lunch_6": t("vp_2000_lunch_6"),
            "vp_2000_lunch_7": t("vp_2000_lunch_7")
        },
        "snack": {
            "vp_2000_snack_1": t("vp_2000_snack_1"),
            "vp_2000_snack_2": t("vp_2000_snack_2"),
            "vp_2000_snack_3": t("vp_2000_snack_3"),
            "vp_2000_snack_4": t("vp_2000_snack_4"),
            "vp_2000_snack_5": t("vp_2000_snack_5"),
            "vp_2000_snack_6": t("vp_2000_snack_6"),
            "vp_2000_snack_7": t("vp_2000_snack_7")
        },
        "dinner": {
            "vp_2000_dinner_1": t("vp_2000_dinner_1"),
            "vp_2000_dinner_2": t("vp_2000_dinner_2"),
            "vp_2000_dinner_3": t("vp_2000_dinner_3"),
            "vp_2000_dinner_4": t("vp_2000_dinner_4"),
            "vp_2000_dinner_5": t("vp_2000_dinner_5"),
            "vp_2000_dinner_6": t("vp_2000_dinner_6"),
            "vp_2000_dinner_7": t("vp_2000_dinner_7")
        }
    },
    "VataPitta_2200": {
        "mdt": {
            "vp_2200_mdt_1": t("vp_2200_mdt_1"),
            "vp_2200_mdt_2": t("vp_2200_mdt_2"),
            "vp_2200_mdt_3": t("vp_2200_mdt_3"),
            "vp_2200_mdt_4": t("vp_2200_mdt_4"),
            "vp_2200_mdt_5": t("vp_2200_mdt_5"),
            "vp_2200_mdt_6": t("vp_2200_mdt_6"),
            "vp_2200_mdt_7": t("vp_2200_mdt_7")
        },
        "mbf": {
            "vp_2200_mbf_1": t("vp_2200_mbf_1"),
            "vp_2200_mbf_2": t("vp_2200_mbf_2"),
            "vp_2200_mbf_3": t("vp_2200_mbf_3"),
            "vp_2200_mbf_4": t("vp_2200_mbf_4"),
            "vp_2200_mbf_5": t("vp_2200_mbf_5"),
            "vp_2200_mbf_6": t("vp_2200_mbf_6"),
            "vp_2200_mbf_7": t("vp_2200_mbf_7")
        },
        "mmb": {
            "vp_2200_mmb_1": t("vp_2200_mmb_1"),
            "vp_2200_mmb_2": t("vp_2200_mmb_2"),
            "vp_2200_mmb_3": t("vp_2200_mmb_3"),
            "vp_2200_mmb_4": t("vp_2200_mmb_4"),
            "vp_2200_mmb_5": t("vp_2200_mmb_5"),
            "vp_2200_mmb_6": t("vp_2200_mmb_6"),
            "vp_2200_mmb_7": t("vp_2200_mmb_7")
        },
        "lunch": {
            "vp_2200_lunch_1": t("vp_2200_lunch_1"),
            "vp_2200_lunch_2": t("vp_2200_lunch_2"),
            "vp_2200_lunch_3": t("vp_2200_lunch_3"),
            "vp_2200_lunch_4": t("vp_2200_lunch_4"),
            "vp_2200_lunch_5": t("vp_2200_lunch_5"),
            "vp_2200_lunch_6": t("vp_2200_lunch_6"),
            "vp_2200_lunch_7": t("vp_2200_lunch_7")
        },
        "snack": {
            "vp_2200_snack_1": t("vp_2200_snack_1"),
            "vp_2200_snack_2": t("vp_2200_snack_2"),
            "vp_2200_snack_3": t("vp_2200_snack_3"),
            "vp_2200_snack_4": t("vp_2200_snack_4"),
            "vp_2200_snack_5": t("vp_2200_snack_5"),
            "vp_2200_snack_6": t("vp_2200_snack_6"),
            "vp_2200_snack_7": t("vp_2200_snack_7")
        },
        "dinner": {
            "vp_2200_dinner_1": t("vp_2200_dinner_1"),
            "vp_2200_dinner_2": t("vp_2200_dinner_2"),
            "vp_2200_dinner_3": t("vp_2200_dinner_3"),
            "vp_2200_dinner_4": t("vp_2200_dinner_4"),
            "vp_2200_dinner_5": t("vp_2200_dinner_5"),
            "vp_2200_dinner_6": t("vp_2200_dinner_6"),
            "vp_2200_dinner_7": t("vp_2200_dinner_7")
        }
    },
    "VataPitta_2400": {
        "mdt": {
            "vp_2400_mdt_1": t("vp_2400_mdt_1"),
            "vp_2400_mdt_2": t("vp_2400_mdt_2"),
            "vp_2400_mdt_3": t("vp_2400_mdt_3"),
            "vp_2400_mdt_4": t("vp_2400_mdt_4"),
            "vp_2400_mdt_5": t("vp_2400_mdt_5"),
            "vp_2400_mdt_6": t("vp_2400_mdt_6"),
            "vp_2400_mdt_7": t("vp_2400_mdt_7")
        },
        "mbf": {
            "vp_2400_mbf_1": t("vp_2400_mbf_1"),
            "vp_2400_mbf_2": t("vp_2400_mbf_2"),
            "vp_2400_mbf_3": t("vp_2400_mbf_3"),
            "vp_2400_mbf_4": t("vp_2400_mbf_4"),
            "vp_2400_mbf_5": t("vp_2400_mbf_5"),
            "vp_2400_mbf_6": t("vp_2400_mbf_6"),
            "vp_2400_mbf_7": t("vp_2400_mbf_7")
        },
        "mmb": {
            "vp_2400_mmb_1": t("vp_2400_mmb_1"),
            "vp_2400_mmb_2": t("vp_2400_mmb_2"),
            "vp_2400_mmb_3": t("vp_2400_mmb_3"),
            "vp_2400_mmb_4": t("vp_2400_mmb_4"),
            "vp_2400_mmb_5": t("vp_2400_mmb_5"),
            "vp_2400_mmb_6": t("vp_2400_mmb_6"),
            "vp_2400_mmb_7": t("vp_2400_mmb_7")
        },
        "lunch": {
            "vp_2400_lunch_1": t("vp_2400_lunch_1"),
            "vp_2400_lunch_2": t("vp_2400_lunch_2"),
            "vp_2400_lunch_3": t("vp_2400_lunch_3"),
            "vp_2400_lunch_4": t("vp_2400_lunch_4"),
            "vp_2400_lunch_5": t("vp_2400_lunch_5"),
            "vp_2400_lunch_6": t("vp_2400_lunch_6"),
            "vp_2400_lunch_7": t("vp_2400_lunch_7")
        },
        "snack": {
            "vp_2400_snack_1": t("vp_2400_snack_1"),
            "vp_2400_snack_2": t("vp_2400_snack_2"),
            "vp_2400_snack_3": t("vp_2400_snack_3"),
            "vp_2400_snack_4": t("vp_2400_snack_4"),
            "vp_2400_snack_5": t("vp_2400_snack_5"),
            "vp_2400_snack_6": t("vp_2400_snack_6"),
            "vp_2400_snack_7": t("vp_2400_snack_7")
        },
        "dinner": {
            "vp_2400_dinner_1": t("vp_2400_dinner_1"),
            "vp_2400_dinner_2": t("vp_2400_dinner_2"),
            "vp_2400_dinner_3": t("vp_2400_dinner_3"),
            "vp_2400_dinner_4": t("vp_2400_dinner_4"),
            "vp_2400_dinner_5": t("vp_2400_dinner_5"),
            "vp_2400_dinner_6": t("vp_2400_dinner_6"),
            "vp_2400_dinner_7": t("vp_2400_dinner_7")
        }
    },
    "VataPitta_2600": {
        "mdt": {
            "vp_2600_mdt_1": t("vp_2600_mdt_1"),
            "vp_2600_mdt_2": t("vp_2600_mdt_2"),
            "vp_2600_mdt_3": t("vp_2600_mdt_3"),
            "vp_2600_mdt_4": t("vp_2600_mdt_4"),
            "vp_2600_mdt_5": t("vp_2600_mdt_5"),
            "vp_2600_mdt_6": t("vp_2600_mdt_6"),
            "vp_2600_mdt_7": t("vp_2600_mdt_7")
        },
        "mbf": {
            "vp_2600_mbf_1": t("vp_2600_mbf_1"),
            "vp_2600_mbf_2": t("vp_2600_mbf_2"),
            "vp_2600_mbf_3": t("vp_2600_mbf_3"),
            "vp_2600_mbf_4": t("vp_2600_mbf_4"),
            "vp_2600_mbf_5": t("vp_2600_mbf_5"),
            "vp_2600_mbf_6": t("vp_2600_mbf_6"),
            "vp_2600_mbf_7": t("vp_2600_mbf_7")
        },
        "mmb": {
            "vp_2600_mmb_1": t("vp_2600_mmb_1"),
            "vp_2600_mmb_2": t("vp_2600_mmb_2"),
            "vp_2600_mmb_3": t("vp_2600_mmb_3"),
            "vp_2600_mmb_4": t("vp_2600_mmb_4"),
            "vp_2600_mmb_5": t("vp_2600_mmb_5"),
            "vp_2600_mmb_6": t("vp_2600_mmb_6"),
            "vp_2600_mmb_7": t("vp_2600_mmb_7")
        },
        "lunch": {
            "vp_2600_lunch_1": t("vp_2600_lunch_1"),
            "vp_2600_lunch_2": t("vp_2600_lunch_2"),
            "vp_2600_lunch_3": t("vp_2600_lunch_3"),
            "vp_2600_lunch_4": t("vp_2600_lunch_4"),
            "vp_2600_lunch_5": t("vp_2600_lunch_5"),
            "vp_2600_lunch_6": t("vp_2600_lunch_6"),
            "vp_2600_lunch_7": t("vp_2600_lunch_7")
        },
        "snack": {
            "vp_2600_snack_1": t("vp_2600_snack_1"),
            "vp_2600_snack_2": t("vp_2600_snack_2"),
            "vp_2600_snack_3": t("vp_2600_snack_3"),
            "vp_2600_snack_4": t("vp_2600_snack_4"),
            "vp_2600_snack_5": t("vp_2600_snack_5"),
            "vp_2600_snack_6": t("vp_2600_snack_6"),
            "vp_2600_snack_7": t("vp_2600_snack_7")
        },
        "dinner": {
            "vp_2600_dinner_1": t("vp_2600_dinner_1"),
            "vp_2600_dinner_2": t("vp_2600_dinner_2"),
            "vp_2600_dinner_3": t("vp_2600_dinner_3"),
            "vp_2600_dinner_4": t("vp_2600_dinner_4"),
            "vp_2600_dinner_5": t("vp_2600_dinner_5"),
            "vp_2600_dinner_6": t("vp_2600_dinner_6"),
            "vp_2600_dinner_7": t("vp_2600_dinner_7")
        }
    },
    "VataPitta_2800": {
        "mdt": {
            "vp_2800_mdt_1": t("vp_2800_mdt_1"),
            "vp_2800_mdt_2": t("vp_2800_mdt_2"),
            "vp_2800_mdt_3": t("vp_2800_mdt_3"),
            "vp_2800_mdt_4": t("vp_2800_mdt_4"),
            "vp_2800_mdt_5": t("vp_2800_mdt_5"),
            "vp_2800_mdt_6": t("vp_2800_mdt_6"),
            "vp_2800_mdt_7": t("vp_2800_mdt_7")
        },
        "mbf": {
            "vp_2800_mbf_1": t("vp_2800_mbf_1"),
            "vp_2800_mbf_2": t("vp_2800_mbf_2"),
            "vp_2800_mbf_3": t("vp_2800_mbf_3"),
            "vp_2800_mbf_4": t("vp_2800_mbf_4"),
            "vp_2800_mbf_5": t("vp_2800_mbf_5"),
            "vp_2800_mbf_6": t("vp_2800_mbf_6"),
            "vp_2800_mbf_7": t("vp_2800_mbf_7")
        },
        "mmb": {
            "vp_2800_mmb_1": t("vp_2800_mmb_1"),
            "vp_2800_mmb_2": t("vp_2800_mmb_2"),
            "vp_2800_mmb_3": t("vp_2800_mmb_3"),
            "vp_2800_mmb_4": t("vp_2800_mmb_4"),
            "vp_2800_mmb_5": t("vp_2800_mmb_5"),
            "vp_2800_mmb_6": t("vp_2800_mmb_6"),
            "vp_2800_mmb_7": t("vp_2800_mmb_7")
        },
        "lunch": {
            "vp_2800_lunch_1": t("vp_2800_lunch_1"),
            "vp_2800_lunch_2": t("vp_2800_lunch_2"),
            "vp_2800_lunch_3": t("vp_2800_lunch_3"),
            "vp_2800_lunch_4": t("vp_2800_lunch_4"),
            "vp_2800_lunch_5": t("vp_2800_lunch_5"),
            "vp_2800_lunch_6": t("vp_2800_lunch_6"),
            "vp_2800_lunch_7": t("vp_2800_lunch_7")
        },
        "snack": {
            "vp_2800_snack_1": t("vp_2800_snack_1"),
            "vp_2800_snack_2": t("vp_2800_snack_2"),
            "vp_2800_snack_3": t("vp_2800_snack_3"),
            "vp_2800_snack_4": t("vp_2800_snack_4"),
            "vp_2800_snack_5": t("vp_2800_snack_5"),
            "vp_2800_snack_6": t("vp_2800_snack_6"),
            "vp_2800_snack_7": t("vp_2800_snack_7")
        },
        "dinner": {
            "vp_2800_dinner_1": t("vp_2800_dinner_1"),
            "vp_2800_dinner_2": t("vp_2800_dinner_2"),
            "vp_2800_dinner_3": t("vp_2800_dinner_3"),
            "vp_2800_dinner_4": t("vp_2800_dinner_4"),
            "vp_2800_dinner_5": t("vp_2800_dinner_5"),
            "vp_2800_dinner_6": t("vp_2800_dinner_6"),
            "vp_2800_dinner_7": t("vp_2800_dinner_7")
        }
    },
    "VataPitta_3000": {
        "mdt": {
            "vp_3000_mdt_1": t("vp_3000_mdt_1"),
            "vp_3000_mdt_2": t("vp_3000_mdt_2"),
            "vp_3000_mdt_3": t("vp_3000_mdt_3"),
            "vp_3000_mdt_4": t("vp_3000_mdt_4"),
            "vp_3000_mdt_5": t("vp_3000_mdt_5"),
            "vp_3000_mdt_6": t("vp_3000_mdt_6"),
            "vp_3000_mdt_7": t("vp_3000_mdt_7")
        },
        "mbf": {
            "vp_3000_mbf_1": t("vp_3000_mbf_1"),
            "vp_3000_mbf_2": t("vp_3000_mbf_2"),
            "vp_3000_mbf_3": t("vp_3000_mbf_3"),
            "vp_3000_mbf_4": t("vp_3000_mbf_4"),
            "vp_3000_mbf_5": t("vp_3000_mbf_5"),
            "vp_3000_mbf_6": t("vp_3000_mbf_6"),
            "vp_3000_mbf_7": t("vp_3000_mbf_7")
        },
        "mmb": {
            "vp_3000_mmb_1": t("vp_3000_mmb_1"),
            "vp_3000_mmb_2": t("vp_3000_mmb_2"),
            "vp_3000_mmb_3": t("vp_3000_mmb_3"),
            "vp_3000_mmb_4": t("vp_3000_mmb_4"),
            "vp_3000_mmb_5": t("vp_3000_mmb_5"),
            "vp_3000_mmb_6": t("vp_3000_mmb_6"),
            "vp_3000_mmb_7": t("vp_3000_mmb_7")
        },
        "lunch": {
            "vp_3000_lunch_1": t("vp_3000_lunch_1"),
            "vp_3000_lunch_2": t("vp_3000_lunch_2"),
            "vp_3000_lunch_3": t("vp_3000_lunch_3"),
            "vp_3000_lunch_4": t("vp_3000_lunch_4"),
            "vp_3000_lunch_5": t("vp_3000_lunch_5"),
            "vp_3000_lunch_6": t("vp_3000_lunch_6"),
            "vp_3000_lunch_7": t("vp_3000_lunch_7")
        },
        "snack": {
            "vp_3000_snack_1": t("vp_3000_snack_1"),
            "vp_3000_snack_2": t("vp_3000_snack_2"),
            "vp_3000_snack_3": t("vp_3000_snack_3"),
            "vp_3000_snack_4": t("vp_3000_snack_4"),
            "vp_3000_snack_5": t("vp_3000_snack_5"),
            "vp_3000_snack_6": t("vp_3000_snack_6"),
            "vp_3000_snack_7": t("vp_3000_snack_7")
        },
        "dinner": {
            "vp_3000_dinner_1": t("vp_3000_dinner_1"),
            "vp_3000_dinner_2": t("vp_3000_dinner_2"),
            "vp_3000_dinner_3": t("vp_3000_dinner_3"),
            "vp_3000_dinner_4": t("vp_3000_dinner_4"),
            "vp_3000_dinner_5": t("vp_3000_dinner_5"),
            "vp_3000_dinner_6": t("vp_3000_dinner_6"),
            "vp_3000_dinner_7": t("vp_3000_dinner_7")
        }
    },


    "VataKapha_1800": {
        "mdt": {
            "vk_1800_mdt_1": t("vk_1800_mdt_1"),
            "vk_1800_mdt_2": t("vk_1800_mdt_2"),
            "vk_1800_mdt_3": t("vk_1800_mdt_3"),
            "vk_1800_mdt_4": t("vk_1800_mdt_4"),
            "vk_1800_mdt_5": t("vk_1800_mdt_5"),
            "vk_1800_mdt_6": t("vk_1800_mdt_6"),
            "vk_1800_mdt_7": t("vk_1800_mdt_7")
        },
        "mbf": {
            "vk_1800_mbf_1": t("vk_1800_mbf_1"),
            "vk_1800_mbf_2": t("vk_1800_mbf_2"),
            "vk_1800_mbf_3": t("vk_1800_mbf_3"),
            "vk_1800_mbf_4": t("vk_1800_mbf_4"),
            "vk_1800_mbf_5": t("vk_1800_mbf_5"),
            "vk_1800_mbf_6": t("vk_1800_mbf_6"),
            "vk_1800_mbf_7": t("vk_1800_mbf_7")
        },
        "mmb": {
            "vk_1800_mmb_1": t("vk_1800_mmb_1"),
            "vk_1800_mmb_2": t("vk_1800_mmb_2"),
            "vk_1800_mmb_3": t("vk_1800_mmb_3"),
            "vk_1800_mmb_4": t("vk_1800_mmb_4"),
            "vk_1800_mmb_5": t("vk_1800_mmb_5"),
            "vk_1800_mmb_6": t("vk_1800_mmb_6"),
            "vk_1800_mmb_7": t("vk_1800_mmb_7")
        },
        "lunch": {
            "vk_1800_lunch_1": t("vk_1800_lunch_1"),
            "vk_1800_lunch_2": t("vk_1800_lunch_2"),
            "vk_1800_lunch_3": t("vk_1800_lunch_3"),
            "vk_1800_lunch_4": t("vk_1800_lunch_4"),
            "vk_1800_lunch_5": t("vk_1800_lunch_5"),
            "vk_1800_lunch_6": t("vk_1800_lunch_6"),
            "vk_1800_lunch_7": t("vk_1800_lunch_7")
        },
        "snack": {
            "vk_1800_snack_1": t("vk_1800_snack_1"),
            "vk_1800_snack_2": t("vk_1800_snack_2"),
            "vk_1800_snack_3": t("vk_1800_snack_3"),
            "vk_1800_snack_4": t("vk_1800_snack_4"),
            "vk_1800_snack_5": t("vk_1800_snack_5"),
            "vk_1800_snack_6": t("vk_1800_snack_6"),
            "vk_1800_snack_7": t("vk_1800_snack_7")
        },
        "dinner": {
            "vk_1800_dinner_1": t("vk_1800_dinner_1"),
            "vk_1800_dinner_2": t("vk_1800_dinner_2"),
            "vk_1800_dinner_3": t("vk_1800_dinner_3"),
            "vk_1800_dinner_4": t("vk_1800_dinner_4"),
            "vk_1800_dinner_5": t("vk_1800_dinner_5"),
            "vk_1800_dinner_6": t("vk_1800_dinner_6"),
            "vk_1800_dinner_7": t("vk_1800_dinner_7")
        }
    },
    "VataKapha_2000": {
        "mdt": {
            "vk_2000_mdt_1": t("vk_2000_mdt_1"),
            "vk_2000_mdt_2": t("vk_2000_mdt_2"),
            "vk_2000_mdt_3": t("vk_2000_mdt_3"),
            "vk_2000_mdt_4": t("vk_2000_mdt_4"),
            "vk_2000_mdt_5": t("vk_2000_mdt_5"),
            "vk_2000_mdt_6": t("vk_2000_mdt_6"),
            "vk_2000_mdt_7": t("vk_2000_mdt_7")
        },
        "mbf": {
            "vk_2000_mbf_1": t("vk_2000_mbf_1"),
            "vk_2000_mbf_2": t("vk_2000_mbf_2"),
            "vk_2000_mbf_3": t("vk_2000_mbf_3"),
            "vk_2000_mbf_4": t("vk_2000_mbf_4"),
            "vk_2000_mbf_5": t("vk_2000_mbf_5"),
            "vk_2000_mbf_6": t("vk_2000_mbf_6"),
            "vk_2000_mbf_7": t("vk_2000_mbf_7")
        },
        "mmb": {
            "vk_2000_mmb_1": t("vk_2000_mmb_1"),
            "vk_2000_mmb_2": t("vk_2000_mmb_2"),
            "vk_2000_mmb_3": t("vk_2000_mmb_3"),
            "vk_2000_mmb_4": t("vk_2000_mmb_4"),
            "vk_2000_mmb_5": t("vk_2000_mmb_5"),
            "vk_2000_mmb_6": t("vk_2000_mmb_6"),
            "vk_2000_mmb_7": t("vk_2000_mmb_7")
        },
        "lunch": {
            "vk_2000_lunch_1": t("vk_2000_lunch_1"),
            "vk_2000_lunch_2": t("vk_2000_lunch_2"),
            "vk_2000_lunch_3": t("vk_2000_lunch_3"),
            "vk_2000_lunch_4": t("vk_2000_lunch_4"),
            "vk_2000_lunch_5": t("vk_2000_lunch_5"),
            "vk_2000_lunch_6": t("vk_2000_lunch_6"),
            "vk_2000_lunch_7": t("vk_2000_lunch_7")
        },
        "snack": {
            "vk_2000_snack_1": t("vk_2000_snack_1"),
            "vk_2000_snack_2": t("vk_2000_snack_2"),
            "vk_2000_snack_3": t("vk_2000_snack_3"),
            "vk_2000_snack_4": t("vk_2000_snack_4"),
            "vk_2000_snack_5": t("vk_2000_snack_5"),
            "vk_2000_snack_6": t("vk_2000_snack_6"),
            "vk_2000_snack_7": t("vk_2000_snack_7")
        },
        "dinner": {
            "vk_2000_dinner_1": t("vk_2000_dinner_1"),
            "vk_2000_dinner_2": t("vk_2000_dinner_2"),
            "vk_2000_dinner_3": t("vk_2000_dinner_3"),
            "vk_2000_dinner_4": t("vk_2000_dinner_4"),
            "vk_2000_dinner_5": t("vk_2000_dinner_5"),
            "vk_2000_dinner_6": t("vk_2000_dinner_6"),
            "vk_2000_dinner_7": t("vk_2000_dinner_7")
        }
    },
    "VataKapha_2200": {
        "mdt": {
            "vk_2200_mdt_1": t("vk_2200_mdt_1"),
            "vk_2200_mdt_2": t("vk_2200_mdt_2"),
            "vk_2200_mdt_3": t("vk_2200_mdt_3"),
            "vk_2200_mdt_4": t("vk_2200_mdt_4"),
            "vk_2200_mdt_5": t("vk_2200_mdt_5"),
            "vk_2200_mdt_6": t("vk_2200_mdt_6"),
            "vk_2200_mdt_7": t("vk_2200_mdt_7")
        },
        "mbf": {
            "vk_2200_mbf_1": t("vk_2200_mbf_1"),
            "vk_2200_mbf_2": t("vk_2200_mbf_2"),
            "vk_2200_mbf_3": t("vk_2200_mbf_3"),
            "vk_2200_mbf_4": t("vk_2200_mbf_4"),
            "vk_2200_mbf_5": t("vk_2200_mbf_5"),
            "vk_2200_mbf_6": t("vk_2200_mbf_6"),
            "vk_2200_mbf_7": t("vk_2200_mbf_7")
        },
        "mmb": {
            "vk_2200_mmb_1": t("vk_2200_mmb_1"),
            "vk_2200_mmb_2": t("vk_2200_mmb_2"),
            "vk_2200_mmb_3": t("vk_2200_mmb_3"),
            "vk_2200_mmb_4": t("vk_2200_mmb_4"),
            "vk_2200_mmb_5": t("vk_2200_mmb_5"),
            "vk_2200_mmb_6": t("vk_2200_mmb_6"),
            "vk_2200_mmb_7": t("vk_2200_mmb_7")
        },
        "lunch": {
            "vk_2200_lunch_1": t("vk_2200_lunch_1"),
            "vk_2200_lunch_2": t("vk_2200_lunch_2"),
            "vk_2200_lunch_3": t("vk_2200_lunch_3"),
            "vk_2200_lunch_4": t("vk_2200_lunch_4"),
            "vk_2200_lunch_5": t("vk_2200_lunch_5"),
            "vk_2200_lunch_6": t("vk_2200_lunch_6"),
            "vk_2200_lunch_7": t("vk_2200_lunch_7")
        },
        "snack": {
            "vk_2200_snack_1": t("vk_2200_snack_1"),
            "vk_2200_snack_2": t("vk_2200_snack_2"),
            "vk_2200_snack_3": t("vk_2200_snack_3"),
            "vk_2200_snack_4": t("vk_2200_snack_4"),
            "vk_2200_snack_5": t("vk_2200_snack_5"),
            "vk_2200_snack_6": t("vk_2200_snack_6"),
            "vk_2200_snack_7": t("vk_2200_snack_7")
        },
        "dinner": {
            "vk_2200_dinner_1": t("vk_2200_dinner_1"),
            "vk_2200_dinner_2": t("vk_2200_dinner_2"),
            "vk_2200_dinner_3": t("vk_2200_dinner_3"),
            "vk_2200_dinner_4": t("vk_2200_dinner_4"),
            "vk_2200_dinner_5": t("vk_2200_dinner_5"),
            "vk_2200_dinner_6": t("vk_2200_dinner_6"),
            "vk_2200_dinner_7": t("vk_2200_dinner_7")
        }
    },
    "VataKapha_2400": {
        "mdt": {
            "vk_2400_mdt_1": t("vk_2400_mdt_1"),
            "vk_2400_mdt_2": t("vk_2400_mdt_2"),
            "vk_2400_mdt_3": t("vk_2400_mdt_3"),
            "vk_2400_mdt_4": t("vk_2400_mdt_4"),
            "vk_2400_mdt_5": t("vk_2400_mdt_5"),
            "vk_2400_mdt_6": t("vk_2400_mdt_6"),
            "vk_2400_mdt_7": t("vk_2400_mdt_7")
        },
        "mbf": {
            "vk_2400_mbf_1": t("vk_2400_mbf_1"),
            "vk_2400_mbf_2": t("vk_2400_mbf_2"),
            "vk_2400_mbf_3": t("vk_2400_mbf_3"),
            "vk_2400_mbf_4": t("vk_2400_mbf_4"),
            "vk_2400_mbf_5": t("vk_2400_mbf_5"),
            "vk_2400_mbf_6": t("vk_2400_mbf_6"),
            "vk_2400_mbf_7": t("vk_2400_mbf_7")
        },
        "mmb": {
            "vk_2400_mmb_1": t("vk_2400_mmb_1"),
            "vk_2400_mmb_2": t("vk_2400_mmb_2"),
            "vk_2400_mmb_3": t("vk_2400_mmb_3"),
            "vk_2400_mmb_4": t("vk_2400_mmb_4"),
            "vk_2400_mmb_5": t("vk_2400_mmb_5"),
            "vk_2400_mmb_6": t("vk_2400_mmb_6"),
            "vk_2400_mmb_7": t("vk_2400_mmb_7")
        },
        "lunch": {
            "vk_2400_lunch_1": t("vk_2400_lunch_1"),
            "vk_2400_lunch_2": t("vk_2400_lunch_2"),
            "vk_2400_lunch_3": t("vk_2400_lunch_3"),
            "vk_2400_lunch_4": t("vk_2400_lunch_4"),
            "vk_2400_lunch_5": t("vk_2400_lunch_5"),
            "vk_2400_lunch_6": t("vk_2400_lunch_6"),
            "vk_2400_lunch_7": t("vk_2400_lunch_7")
        },
        "snack": {
            "vk_2400_snack_1": t("vk_2400_snack_1"),
            "vk_2400_snack_2": t("vk_2400_snack_2"),
            "vk_2400_snack_3": t("vk_2400_snack_3"),
            "vk_2400_snack_4": t("vk_2400_snack_4"),
            "vk_2400_snack_5": t("vk_2400_snack_5"),
            "vk_2400_snack_6": t("vk_2400_snack_6"),
            "vk_2400_snack_7": t("vk_2400_snack_7")
        },
        "dinner": {
            "vk_2400_dinner_1": t("vk_2400_dinner_1"),
            "vk_2400_dinner_2": t("vk_2400_dinner_2"),
            "vk_2400_dinner_3": t("vk_2400_dinner_3"),
            "vk_2400_dinner_4": t("vk_2400_dinner_4"),
            "vk_2400_dinner_5": t("vk_2400_dinner_5"),
            "vk_2400_dinner_6": t("vk_2400_dinner_6"),
            "vk_2400_dinner_7": t("vk_2400_dinner_7")
        }
    },
    "VataKapha_2600": {
        "mdt": {
            "vk_2600_mdt_1": t("vk_2600_mdt_1"),
            "vk_2600_mdt_2": t("vk_2600_mdt_2"),
            "vk_2600_mdt_3": t("vk_2600_mdt_3"),
            "vk_2600_mdt_4": t("vk_2600_mdt_4"),
            "vk_2600_mdt_5": t("vk_2600_mdt_5"),
            "vk_2600_mdt_6": t("vk_2600_mdt_6"),
            "vk_2600_mdt_7": t("vk_2600_mdt_7")
        },
        "mbf": {
            "vk_2600_mbf_1": t("vk_2600_mbf_1"),
            "vk_2600_mbf_2": t("vk_2600_mbf_2"),
            "vk_2600_mbf_3": t("vk_2600_mbf_3"),
            "vk_2600_mbf_4": t("vk_2600_mbf_4"),
            "vk_2600_mbf_5": t("vk_2600_mbf_5"),
            "vk_2600_mbf_6": t("vk_2600_mbf_6"),
            "vk_2600_mbf_7": t("vk_2600_mbf_7")
        },
        "mmb": {
            "vk_2600_mmb_1": t("vk_2600_mmb_1"),
            "vk_2600_mmb_2": t("vk_2600_mmb_2"),
            "vk_2600_mmb_3": t("vk_2600_mmb_3"),
            "vk_2600_mmb_4": t("vk_2600_mmb_4"),
            "vk_2600_mmb_5": t("vk_2600_mmb_5"),
            "vk_2600_mmb_6": t("vk_2600_mmb_6"),
            "vk_2600_mmb_7": t("vk_2600_mmb_7")
        },
        "lunch": {
            "vk_2600_lunch_1": t("vk_2600_lunch_1"),
            "vk_2600_lunch_2": t("vk_2600_lunch_2"),
            "vk_2600_lunch_3": t("vk_2600_lunch_3"),
            "vk_2600_lunch_4": t("vk_2600_lunch_4"),
            "vk_2600_lunch_5": t("vk_2600_lunch_5"),
            "vk_2600_lunch_6": t("vk_2600_lunch_6"),
            "vk_2600_lunch_7": t("vk_2600_lunch_7")
        },
        "snack": {
            "vk_2600_snack_1": t("vk_2600_snack_1"),
            "vk_2600_snack_2": t("vk_2600_snack_2"),
            "vk_2600_snack_3": t("vk_2600_snack_3"),
            "vk_2600_snack_4": t("vk_2600_snack_4"),
            "vk_2600_snack_5": t("vk_2600_snack_5"),
            "vk_2600_snack_6": t("vk_2600_snack_6"),
            "vk_2600_snack_7": t("vk_2600_snack_7")
        },
        "dinner": {
            "vk_2600_dinner_1": t("vk_2600_dinner_1"),
            "vk_2600_dinner_2": t("vk_2600_dinner_2"),
            "vk_2600_dinner_3": t("vk_2600_dinner_3"),
            "vk_2600_dinner_4": t("vk_2600_dinner_4"),
            "vk_2600_dinner_5": t("vk_2600_dinner_5"),
            "vk_2600_dinner_6": t("vk_2600_dinner_6"),
            "vk_2600_dinner_7": t("vk_2600_dinner_7")
        }
    },
    "VataKapha_2800": {
        "mdt": {
            "vk_2800_mdt_1": t("vk_2800_mdt_1"),
            "vk_2800_mdt_2": t("vk_2800_mdt_2"),
            "vk_2800_mdt_3": t("vk_2800_mdt_3"),
            "vk_2800_mdt_4": t("vk_2800_mdt_4"),
            "vk_2800_mdt_5": t("vk_2800_mdt_5"),
            "vk_2800_mdt_6": t("vk_2800_mdt_6"),
            "vk_2800_mdt_7": t("vk_2800_mdt_7")
        },
        "mbf": {
            "vk_2800_mbf_1": t("vk_2800_mbf_1"),
            "vk_2800_mbf_2": t("vk_2800_mbf_2"),
            "vk_2800_mbf_3": t("vk_2800_mbf_3"),
            "vk_2800_mbf_4": t("vk_2800_mbf_4"),
            "vk_2800_mbf_5": t("vk_2800_mbf_5"),
            "vk_2800_mbf_6": t("vk_2800_mbf_6"),
            "vk_2800_mbf_7": t("vk_2800_mbf_7")
        },
        "mmb": {
            "vk_2800_mmb_1": t("vk_2800_mmb_1"),
            "vk_2800_mmb_2": t("vk_2800_mmb_2"),
            "vk_2800_mmb_3": t("vk_2800_mmb_3"),
            "vk_2800_mmb_4": t("vk_2800_mmb_4"),
            "vk_2800_mmb_5": t("vk_2800_mmb_5"),
            "vk_2800_mmb_6": t("vk_2800_mmb_6"),
            "vk_2800_mmb_7": t("vk_2800_mmb_7")
        },
        "lunch": {
            "vk_2800_lunch_1": t("vk_2800_lunch_1"),
            "vk_2800_lunch_2": t("vk_2800_lunch_2"),
            "vk_2800_lunch_3": t("vk_2800_lunch_3"),
            "vk_2800_lunch_4": t("vk_2800_lunch_4"),
            "vk_2800_lunch_5": t("vk_2800_lunch_5"),
            "vk_2800_lunch_6": t("vk_2800_lunch_6"),
            "vk_2800_lunch_7": t("vk_2800_lunch_7")
        },
        "snack": {
            "vk_2800_snack_1": t("vk_2800_snack_1"),
            "vk_2800_snack_2": t("vk_2800_snack_2"),
            "vk_2800_snack_3": t("vk_2800_snack_3"),
            "vk_2800_snack_4": t("vk_2800_snack_4"),
            "vk_2800_snack_5": t("vk_2800_snack_5"),
            "vk_2800_snack_6": t("vk_2800_snack_6"),
            "vk_2800_snack_7": t("vk_2800_snack_7")
        },
        "dinner": {
            "vk_2800_dinner_1": t("vk_2800_dinner_1"),
            "vk_2800_dinner_2": t("vk_2800_dinner_2"),
            "vk_2800_dinner_3": t("vk_2800_dinner_3"),
            "vk_2800_dinner_4": t("vk_2800_dinner_4"),
            "vk_2800_dinner_5": t("vk_2800_dinner_5"),
            "vk_2800_dinner_6": t("vk_2800_dinner_6"),
            "vk_2800_dinner_7": t("vk_2800_dinner_7")
        }
    },
    "VataKapha_3000": {
        "mdt": {
            "vk_3000_mdt_1": t("vk_3000_mdt_1"),
            "vk_3000_mdt_2": t("vk_3000_mdt_2"),
            "vk_3000_mdt_3": t("vk_3000_mdt_3"),
            "vk_3000_mdt_4": t("vk_3000_mdt_4"),
            "vk_3000_mdt_5": t("vk_3000_mdt_5"),
            "vk_3000_mdt_6": t("vk_3000_mdt_6"),
            "vk_3000_mdt_7": t("vk_3000_mdt_7")
        },
        "mbf": {
            "vk_3000_mbf_1": t("vk_3000_mbf_1"),
            "vk_3000_mbf_2": t("vk_3000_mbf_2"),
            "vk_3000_mbf_3": t("vk_3000_mbf_3"),
            "vk_3000_mbf_4": t("vk_3000_mbf_4"),
            "vk_3000_mbf_5": t("vk_3000_mbf_5"),
            "vk_3000_mbf_6": t("vk_3000_mbf_6"),
            "vk_3000_mbf_7": t("vk_3000_mbf_7")
        },
        "mmb": {
            "vk_3000_mmb_1": t("vk_3000_mmb_1"),
            "vk_3000_mmb_2": t("vk_3000_mmb_2"),
            "vk_3000_mmb_3": t("vk_3000_mmb_3"),
            "vk_3000_mmb_4": t("vk_3000_mmb_4"),
            "vk_3000_mmb_5": t("vk_3000_mmb_5"),
            "vk_3000_mmb_6": t("vk_3000_mmb_6"),
            "vk_3000_mmb_7": t("vk_3000_mmb_7")
        },
        "lunch": {
            "vk_3000_lunch_1": t("vk_3000_lunch_1"),
            "vk_3000_lunch_2": t("vk_3000_lunch_2"),
            "vk_3000_lunch_3": t("vk_3000_lunch_3"),
            "vk_3000_lunch_4": t("vk_3000_lunch_4"),
            "vk_3000_lunch_5": t("vk_3000_lunch_5"),
            "vk_3000_lunch_6": t("vk_3000_lunch_6"),
            "vk_3000_lunch_7": t("vk_3000_lunch_7")
        },
        "snack": {
            "vk_3000_snack_1": t("vk_3000_snack_1"),
            "vk_3000_snack_2": t("vk_3000_snack_2"),
            "vk_3000_snack_3": t("vk_3000_snack_3"),
            "vk_3000_snack_4": t("vk_3000_snack_4"),
            "vk_3000_snack_5": t("vk_3000_snack_5"),
            "vk_3000_snack_6": t("vk_3000_snack_6"),
            "vk_3000_snack_7": t("vk_3000_snack_7")
        },
        "dinner": {
            "vk_3000_dinner_1": t("vk_3000_dinner_1"),
            "vk_3000_dinner_2": t("vk_3000_dinner_2"),
            "vk_3000_dinner_3": t("vk_3000_dinner_3"),
            "vk_3000_dinner_4": t("vk_3000_dinner_4"),
            "vk_3000_dinner_5": t("vk_3000_dinner_5"),
            "vk_3000_dinner_6": t("vk_3000_dinner_6"),
            "vk_3000_dinner_7": t("vk_3000_dinner_7")
        }
    },
    

    "PittaVata_1800": {
        "mdt": {
            "pv_1800_mdt_1": t("pv_1800_mdt_1"),
            "pv_1800_mdt_2": t("pv_1800_mdt_2"),
            "pv_1800_mdt_3": t("pv_1800_mdt_3"),
            "pv_1800_mdt_4": t("pv_1800_mdt_4"),
            "pv_1800_mdt_5": t("pv_1800_mdt_5"),
            "pv_1800_mdt_6": t("pv_1800_mdt_6"),
            "pv_1800_mdt_7": t("pv_1800_mdt_7")
        },
        "mbf": {
            "pv_1800_mbf_1": t("pv_1800_mbf_1"),
            "pv_1800_mbf_2": t("pv_1800_mbf_2"),
            "pv_1800_mbf_3": t("pv_1800_mbf_3"),
            "pv_1800_mbf_4": t("pv_1800_mbf_4"),
            "pv_1800_mbf_5": t("pv_1800_mbf_5"),
            "pv_1800_mbf_6": t("pv_1800_mbf_6"),
            "pv_1800_mbf_7": t("pv_1800_mbf_7")
        },
        "mmb": {
            "pv_1800_mmb_1": t("pv_1800_mmb_1"),
            "pv_1800_mmb_2": t("pv_1800_mmb_2"),
            "pv_1800_mmb_3": t("pv_1800_mmb_3"),
            "pv_1800_mmb_4": t("pv_1800_mmb_4"),
            "pv_1800_mmb_5": t("pv_1800_mmb_5"),
            "pv_1800_mmb_6": t("pv_1800_mmb_6"),
            "pv_1800_mmb_7": t("pv_1800_mmb_7")
        },
        "lunch": {
            "pv_1800_lunch_1": t("pv_1800_lunch_1"),
            "pv_1800_lunch_2": t("pv_1800_lunch_2"),
            "pv_1800_lunch_3": t("pv_1800_lunch_3"),
            "pv_1800_lunch_4": t("pv_1800_lunch_4"),
            "pv_1800_lunch_5": t("pv_1800_lunch_5"),
            "pv_1800_lunch_6": t("pv_1800_lunch_6"),
            "pv_1800_lunch_7": t("pv_1800_lunch_7")
        },
        "snack": {
            "pv_1800_snack_1": t("pv_1800_snack_1"),
            "pv_1800_snack_2": t("pv_1800_snack_2"),
            "pv_1800_snack_3": t("pv_1800_snack_3"),
            "pv_1800_snack_4": t("pv_1800_snack_4"),
            "pv_1800_snack_5": t("pv_1800_snack_5"),
            "pv_1800_snack_6": t("pv_1800_snack_6"),
            "pv_1800_snack_7": t("pv_1800_snack_7")
        },
        "dinner": {
            "pv_1800_dinner_1": t("pv_1800_dinner_1"),
            "pv_1800_dinner_2": t("pv_1800_dinner_2"),
            "pv_1800_dinner_3": t("pv_1800_dinner_3"),
            "pv_1800_dinner_4": t("pv_1800_dinner_4"),
            "pv_1800_dinner_5": t("pv_1800_dinner_5"),
            "pv_1800_dinner_6": t("pv_1800_dinner_6"),
            "pv_1800_dinner_7": t("pv_1800_dinner_7")
        }
    },
    "PittaVata_2000": {
        "mdt": {
            "pv_2000_mdt_1": t("pv_2000_mdt_1"),
            "pv_2000_mdt_2": t("pv_2000_mdt_2"),
            "pv_2000_mdt_3": t("pv_2000_mdt_3"),
            "pv_2000_mdt_4": t("pv_2000_mdt_4"),
            "pv_2000_mdt_5": t("pv_2000_mdt_5"),
            "pv_2000_mdt_6": t("pv_2000_mdt_6"),
            "pv_2000_mdt_7": t("pv_2000_mdt_7")
        },
        "mbf": {
            "pv_2000_mbf_1": t("pv_2000_mbf_1"),
            "pv_2000_mbf_2": t("pv_2000_mbf_2"),
            "pv_2000_mbf_3": t("pv_2000_mbf_3"),
            "pv_2000_mbf_4": t("pv_2000_mbf_4"),
            "pv_2000_mbf_5": t("pv_2000_mbf_5"),
            "pv_2000_mbf_6": t("pv_2000_mbf_6"),
            "pv_2000_mbf_7": t("pv_2000_mbf_7")
        },
        "mmb": {
            "pv_2000_mmb_1": t("pv_2000_mmb_1"),
            "pv_2000_mmb_2": t("pv_2000_mmb_2"),
            "pv_2000_mmb_3": t("pv_2000_mmb_3"),
            "pv_2000_mmb_4": t("pv_2000_mmb_4"),
            "pv_2000_mmb_5": t("pv_2000_mmb_5"),
            "pv_2000_mmb_6": t("pv_2000_mmb_6"),
            "pv_2000_mmb_7": t("pv_2000_mmb_7")
        },
        "lunch": {
            "pv_2000_lunch_1": t("pv_2000_lunch_1"),
            "pv_2000_lunch_2": t("pv_2000_lunch_2"),
            "pv_2000_lunch_3": t("pv_2000_lunch_3"),
            "pv_2000_lunch_4": t("pv_2000_lunch_4"),
            "pv_2000_lunch_5": t("pv_2000_lunch_5"),
            "pv_2000_lunch_6": t("pv_2000_lunch_6"),
            "pv_2000_lunch_7": t("pv_2000_lunch_7")
        },
        "snack": {
            "pv_2000_snack_1": t("pv_2000_snack_1"),
            "pv_2000_snack_2": t("pv_2000_snack_2"),
            "pv_2000_snack_3": t("pv_2000_snack_3"),
            "pv_2000_snack_4": t("pv_2000_snack_4"),
            "pv_2000_snack_5": t("pv_2000_snack_5"),
            "pv_2000_snack_6": t("pv_2000_snack_6"),
            "pv_2000_snack_7": t("pv_2000_snack_7")
        },
        "dinner": {
            "pv_2000_dinner_1": t("pv_2000_dinner_1"),
            "pv_2000_dinner_2": t("pv_2000_dinner_2"),
            "pv_2000_dinner_3": t("pv_2000_dinner_3"),
            "pv_2000_dinner_4": t("pv_2000_dinner_4"),
            "pv_2000_dinner_5": t("pv_2000_dinner_5"),
            "pv_2000_dinner_6": t("pv_2000_dinner_6"),
            "pv_2000_dinner_7": t("pv_2000_dinner_7")
        }
    },
    "PittaVata_2200": {
        "mdt": {
            "pv_2200_mdt_1": t("pv_2200_mdt_1"),
            "pv_2200_mdt_2": t("pv_2200_mdt_2"),
            "pv_2200_mdt_3": t("pv_2200_mdt_3"),
            "pv_2200_mdt_4": t("pv_2200_mdt_4"),
            "pv_2200_mdt_5": t("pv_2200_mdt_5"),
            "pv_2200_mdt_6": t("pv_2200_mdt_6"),
            "pv_2200_mdt_7": t("pv_2200_mdt_7")
        },
        "mbf": {
            "pv_2200_mbf_1": t("pv_2200_mbf_1"),
            "pv_2200_mbf_2": t("pv_2200_mbf_2"),
            "pv_2200_mbf_3": t("pv_2200_mbf_3"),
            "pv_2200_mbf_4": t("pv_2200_mbf_4"),
            "pv_2200_mbf_5": t("pv_2200_mbf_5"),
            "pv_2200_mbf_6": t("pv_2200_mbf_6"),
            "pv_2200_mbf_7": t("pv_2200_mbf_7")
        },
        "mmb": {
            "pv_2200_mmb_1": t("pv_2200_mmb_1"),
            "pv_2200_mmb_2": t("pv_2200_mmb_2"),
            "pv_2200_mmb_3": t("pv_2200_mmb_3"),
            "pv_2200_mmb_4": t("pv_2200_mmb_4"),
            "pv_2200_mmb_5": t("pv_2200_mmb_5"),
            "pv_2200_mmb_6": t("pv_2200_mmb_6"),
            "pv_2200_mmb_7": t("pv_2200_mmb_7")
        },
        "lunch": {
            "pv_2200_lunch_1": t("pv_2200_lunch_1"),
            "pv_2200_lunch_2": t("pv_2200_lunch_2"),
            "pv_2200_lunch_3": t("pv_2200_lunch_3"),
            "pv_2200_lunch_4": t("pv_2200_lunch_4"),
            "pv_2200_lunch_5": t("pv_2200_lunch_5"),
            "pv_2200_lunch_6": t("pv_2200_lunch_6"),
            "pv_2200_lunch_7": t("pv_2200_lunch_7")
        },
        "snack": {
            "pv_2200_snack_1": t("pv_2200_snack_1"),
            "pv_2200_snack_2": t("pv_2200_snack_2"),
            "pv_2200_snack_3": t("pv_2200_snack_3"),
            "pv_2200_snack_4": t("pv_2200_snack_4"),
            "pv_2200_snack_5": t("pv_2200_snack_5"),
            "pv_2200_snack_6": t("pv_2200_snack_6"),
            "pv_2200_snack_7": t("pv_2200_snack_7")
        },
        "dinner": {
            "pv_2200_dinner_1": t("pv_2200_dinner_1"),
            "pv_2200_dinner_2": t("pv_2200_dinner_2"),
            "pv_2200_dinner_3": t("pv_2200_dinner_3"),
            "pv_2200_dinner_4": t("pv_2200_dinner_4"),
            "pv_2200_dinner_5": t("pv_2200_dinner_5"),
            "pv_2200_dinner_6": t("pv_2200_dinner_6"),
            "pv_2200_dinner_7": t("pv_2200_dinner_7")
        }
    },
    "PittaVata_2400": {
        "mdt": {
            "pv_2400_mdt_1": t("pv_2400_mdt_1"),
            "pv_2400_mdt_2": t("pv_2400_mdt_2"),
            "pv_2400_mdt_3": t("pv_2400_mdt_3"),
            "pv_2400_mdt_4": t("pv_2400_mdt_4"),
            "pv_2400_mdt_5": t("pv_2400_mdt_5"),
            "pv_2400_mdt_6": t("pv_2400_mdt_6"),
            "pv_2400_mdt_7": t("pv_2400_mdt_7")
        },
        "mbf": {
            "pv_2400_mbf_1": t("pv_2400_mbf_1"),
            "pv_2400_mbf_2": t("pv_2400_mbf_2"),
            "pv_2400_mbf_3": t("pv_2400_mbf_3"),
            "pv_2400_mbf_4": t("pv_2400_mbf_4"),
            "pv_2400_mbf_5": t("pv_2400_mbf_5"),
            "pv_2400_mbf_6": t("pv_2400_mbf_6"),
            "pv_2400_mbf_7": t("pv_2400_mbf_7")
        },
        "mmb": {
            "pv_2400_mmb_1": t("pv_2400_mmb_1"),
            "pv_2400_mmb_2": t("pv_2400_mmb_2"),
            "pv_2400_mmb_3": t("pv_2400_mmb_3"),
            "pv_2400_mmb_4": t("pv_2400_mmb_4"),
            "pv_2400_mmb_5": t("pv_2400_mmb_5"),
            "pv_2400_mmb_6": t("pv_2400_mmb_6"),
            "pv_2400_mmb_7": t("pv_2400_mmb_7")
        },
        "lunch": {
            "pv_2400_lunch_1": t("pv_2400_lunch_1"),
            "pv_2400_lunch_2": t("pv_2400_lunch_2"),
            "pv_2400_lunch_3": t("pv_2400_lunch_3"),
            "pv_2400_lunch_4": t("pv_2400_lunch_4"),
            "pv_2400_lunch_5": t("pv_2400_lunch_5"),
            "pv_2400_lunch_6": t("pv_2400_lunch_6"),
            "pv_2400_lunch_7": t("pv_2400_lunch_7")
        },
        "snack": {
            "pv_2400_snack_1": t("pv_2400_snack_1"),
            "pv_2400_snack_2": t("pv_2400_snack_2"),
            "pv_2400_snack_3": t("pv_2400_snack_3"),
            "pv_2400_snack_4": t("pv_2400_snack_4"),
            "pv_2400_snack_5": t("pv_2400_snack_5"),
            "pv_2400_snack_6": t("pv_2400_snack_6"),
            "pv_2400_snack_7": t("pv_2400_snack_7")
        },
        "dinner": {
            "pv_2400_dinner_1": t("pv_2400_dinner_1"),
            "pv_2400_dinner_2": t("pv_2400_dinner_2"),
            "pv_2400_dinner_3": t("pv_2400_dinner_3"),
            "pv_2400_dinner_4": t("pv_2400_dinner_4"),
            "pv_2400_dinner_5": t("pv_2400_dinner_5"),
            "pv_2400_dinner_6": t("pv_2400_dinner_6"),
            "pv_2400_dinner_7": t("pv_2400_dinner_7")
        }
    },
    "PittaVata_2600": {
        "mdt": {
            "pv_2600_mdt_1": t("pv_2600_mdt_1"),
            "pv_2600_mdt_2": t("pv_2600_mdt_2"),
            "pv_2600_mdt_3": t("pv_2600_mdt_3"),
            "pv_2600_mdt_4": t("pv_2600_mdt_4"),
            "pv_2600_mdt_5": t("pv_2600_mdt_5"),
            "pv_2600_mdt_6": t("pv_2600_mdt_6"),
            "pv_2600_mdt_7": t("pv_2600_mdt_7")
        },
        "mbf": {
            "pv_2600_mbf_1": t("pv_2600_mbf_1"),
            "pv_2600_mbf_2": t("pv_2600_mbf_2"),
            "pv_2600_mbf_3": t("pv_2600_mbf_3"),
            "pv_2600_mbf_4": t("pv_2600_mbf_4"),
            "pv_2600_mbf_5": t("pv_2600_mbf_5"),
            "pv_2600_mbf_6": t("pv_2600_mbf_6"),
            "pv_2600_mbf_7": t("pv_2600_mbf_7")
        },
        "mmb": {
            "pv_2600_mmb_1": t("pv_2600_mmb_1"),
            "pv_2600_mmb_2": t("pv_2600_mmb_2"),
            "pv_2600_mmb_3": t("pv_2600_mmb_3"),
            "pv_2600_mmb_4": t("pv_2600_mmb_4"),
            "pv_2600_mmb_5": t("pv_2600_mmb_5"),
            "pv_2600_mmb_6": t("pv_2600_mmb_6"),
            "pv_2600_mmb_7": t("pv_2600_mmb_7")
        },
        "lunch": {
            "pv_2600_lunch_1": t("pv_2600_lunch_1"),
            "pv_2600_lunch_2": t("pv_2600_lunch_2"),
            "pv_2600_lunch_3": t("pv_2600_lunch_3"),
            "pv_2600_lunch_4": t("pv_2600_lunch_4"),
            "pv_2600_lunch_5": t("pv_2600_lunch_5"),
            "pv_2600_lunch_6": t("pv_2600_lunch_6"),
            "pv_2600_lunch_7": t("pv_2600_lunch_7")
        },
        "snack": {
            "pv_2600_snack_1": t("pv_2600_snack_1"),
            "pv_2600_snack_2": t("pv_2600_snack_2"),
            "pv_2600_snack_3": t("pv_2600_snack_3"),
            "pv_2600_snack_4": t("pv_2600_snack_4"),
            "pv_2600_snack_5": t("pv_2600_snack_5"),
            "pv_2600_snack_6": t("pv_2600_snack_6"),
            "pv_2600_snack_7": t("pv_2600_snack_7")
        },
        "dinner": {
            "pv_2600_dinner_1": t("pv_2600_dinner_1"),
            "pv_2600_dinner_2": t("pv_2600_dinner_2"),
            "pv_2600_dinner_3": t("pv_2600_dinner_3"),
            "pv_2600_dinner_4": t("pv_2600_dinner_4"),
            "pv_2600_dinner_5": t("pv_2600_dinner_5"),
            "pv_2600_dinner_6": t("pv_2600_dinner_6"),
            "pv_2600_dinner_7": t("pv_2600_dinner_7")
        }
    },
    "PittaVata_2800": {
        "mdt": {
            "pv_2800_mdt_1": t("pv_2800_mdt_1"),
            "pv_2800_mdt_2": t("pv_2800_mdt_2"),
            "pv_2800_mdt_3": t("pv_2800_mdt_3"),
            "pv_2800_mdt_4": t("pv_2800_mdt_4"),
            "pv_2800_mdt_5": t("pv_2800_mdt_5"),
            "pv_2800_mdt_6": t("pv_2800_mdt_6"),
            "pv_2800_mdt_7": t("pv_2800_mdt_7")
        },
        "mbf": {
            "pv_2800_mbf_1": t("pv_2800_mbf_1"),
            "pv_2800_mbf_2": t("pv_2800_mbf_2"),
            "pv_2800_mbf_3": t("pv_2800_mbf_3"),
            "pv_2800_mbf_4": t("pv_2800_mbf_4"),
            "pv_2800_mbf_5": t("pv_2800_mbf_5"),
            "pv_2800_mbf_6": t("pv_2800_mbf_6"),
            "pv_2800_mbf_7": t("pv_2800_mbf_7")
        },
        "mmb": {
            "pv_2800_mmb_1": t("pv_2800_mmb_1"),
            "pv_2800_mmb_2": t("pv_2800_mmb_2"),
            "pv_2800_mmb_3": t("pv_2800_mmb_3"),
            "pv_2800_mmb_4": t("pv_2800_mmb_4"),
            "pv_2800_mmb_5": t("pv_2800_mmb_5"),
            "pv_2800_mmb_6": t("pv_2800_mmb_6"),
            "pv_2800_mmb_7": t("pv_2800_mmb_7")
        },
        "lunch": {
            "pv_2800_lunch_1": t("pv_2800_lunch_1"),
            "pv_2800_lunch_2": t("pv_2800_lunch_2"),
            "pv_2800_lunch_3": t("pv_2800_lunch_3"),
            "pv_2800_lunch_4": t("pv_2800_lunch_4"),
            "pv_2800_lunch_5": t("pv_2800_lunch_5"),
            "pv_2800_lunch_6": t("pv_2800_lunch_6"),
            "pv_2800_lunch_7": t("pv_2800_lunch_7")
        },
        "snack": {
            "pv_2800_snack_1": t("pv_2800_snack_1"),
            "pv_2800_snack_2": t("pv_2800_snack_2"),
            "pv_2800_snack_3": t("pv_2800_snack_3"),
            "pv_2800_snack_4": t("pv_2800_snack_4"),
            "pv_2800_snack_5": t("pv_2800_snack_5"),
            "pv_2800_snack_6": t("pv_2800_snack_6"),
            "pv_2800_snack_7": t("pv_2800_snack_7")
        },
        "dinner": {
            "pv_2800_dinner_1": t("pv_2800_dinner_1"),
            "pv_2800_dinner_2": t("pv_2800_dinner_2"),
            "pv_2800_dinner_3": t("pv_2800_dinner_3"),
            "pv_2800_dinner_4": t("pv_2800_dinner_4"),
            "pv_2800_dinner_5": t("pv_2800_dinner_5"),
            "pv_2800_dinner_6": t("pv_2800_dinner_6"),
            "pv_2800_dinner_7": t("pv_2800_dinner_7")
        }
    },
    "PittaVata_3000": {
        "mdt": {
            "pv_3000_mdt_1": t("pv_3000_mdt_1"),
            "pv_3000_mdt_2": t("pv_3000_mdt_2"),
            "pv_3000_mdt_3": t("pv_3000_mdt_3"),
            "pv_3000_mdt_4": t("pv_3000_mdt_4"),
            "pv_3000_mdt_5": t("pv_3000_mdt_5"),
            "pv_3000_mdt_6": t("pv_3000_mdt_6"),
            "pv_3000_mdt_7": t("pv_3000_mdt_7")
        },
        "mbf": {
            "pv_3000_mbf_1": t("pv_3000_mbf_1"),
            "pv_3000_mbf_2": t("pv_3000_mbf_2"),
            "pv_3000_mbf_3": t("pv_3000_mbf_3"),
            "pv_3000_mbf_4": t("pv_3000_mbf_4"),
            "pv_3000_mbf_5": t("pv_3000_mbf_5"),
            "pv_3000_mbf_6": t("pv_3000_mbf_6"),
            "pv_3000_mbf_7": t("pv_3000_mbf_7")
        },
        "mmb": {
            "pv_3000_mmb_1": t("pv_3000_mmb_1"),
            "pv_3000_mmb_2": t("pv_3000_mmb_2"),
            "pv_3000_mmb_3": t("pv_3000_mmb_3"),
            "pv_3000_mmb_4": t("pv_3000_mmb_4"),
            "pv_3000_mmb_5": t("pv_3000_mmb_5"),
            "pv_3000_mmb_6": t("pv_3000_mmb_6"),
            "pv_3000_mmb_7": t("pv_3000_mmb_7")
        },
        "lunch": {
            "pv_3000_lunch_1": t("pv_3000_lunch_1"),
            "pv_3000_lunch_2": t("pv_3000_lunch_2"),
            "pv_3000_lunch_3": t("pv_3000_lunch_3"),
            "pv_3000_lunch_4": t("pv_3000_lunch_4"),
            "pv_3000_lunch_5": t("pv_3000_lunch_5"),
            "pv_3000_lunch_6": t("pv_3000_lunch_6"),
            "pv_3000_lunch_7": t("pv_3000_lunch_7")
        },
        "snack": {
            "pv_3000_snack_1": t("pv_3000_snack_1"),
            "pv_3000_snack_2": t("pv_3000_snack_2"),
            "pv_3000_snack_3": t("pv_3000_snack_3"),
            "pv_3000_snack_4": t("pv_3000_snack_4"),
            "pv_3000_snack_5": t("pv_3000_snack_5"),
            "pv_3000_snack_6": t("pv_3000_snack_6"),
            "pv_3000_snack_7": t("pv_3000_snack_7")
        },
        "dinner": {
            "pv_3000_dinner_1": t("pv_3000_dinner_1"),
            "pv_3000_dinner_2": t("pv_3000_dinner_2"),
            "pv_3000_dinner_3": t("pv_3000_dinner_3"),
            "pv_3000_dinner_4": t("pv_3000_dinner_4"),
            "pv_3000_dinner_5": t("pv_3000_dinner_5"),
            "pv_3000_dinner_6": t("pv_3000_dinner_6"),
            "pv_3000_dinner_7": t("pv_3000_dinner_7")
        }
    },


    "PittaKapha_1800": {
        "mdt": {
            "pk_1800_mdt_1": t("pk_1800_mdt_1"),
            "pk_1800_mdt_2": t("pk_1800_mdt_2"),
            "pk_1800_mdt_3": t("pk_1800_mdt_3"),
            "pk_1800_mdt_4": t("pk_1800_mdt_4"),
            "pk_1800_mdt_5": t("pk_1800_mdt_5"),
            "pk_1800_mdt_6": t("pk_1800_mdt_6"),
            "pk_1800_mdt_7": t("pk_1800_mdt_7")
        },
        "mbf": {
            "pk_1800_mbf_1": t("pk_1800_mbf_1"),
            "pk_1800_mbf_2": t("pk_1800_mbf_2"),
            "pk_1800_mbf_3": t("pk_1800_mbf_3"),
            "pk_1800_mbf_4": t("pk_1800_mbf_4"),
            "pk_1800_mbf_5": t("pk_1800_mbf_5"),
            "pk_1800_mbf_6": t("pk_1800_mbf_6"),
            "pk_1800_mbf_7": t("pk_1800_mbf_7")
        },
        "mmb": {
            "pk_1800_mmb_1": t("pk_1800_mmb_1"),
            "pk_1800_mmb_2": t("pk_1800_mmb_2"),
            "pk_1800_mmb_3": t("pk_1800_mmb_3"),
            "pk_1800_mmb_4": t("pk_1800_mmb_4"),
            "pk_1800_mmb_5": t("pk_1800_mmb_5"),
            "pk_1800_mmb_6": t("pk_1800_mmb_6"),
            "pk_1800_mmb_7": t("pk_1800_mmb_7")
        },
        "lunch": {
            "pk_1800_lunch_1": t("pk_1800_lunch_1"),
            "pk_1800_lunch_2": t("pk_1800_lunch_2"),
            "pk_1800_lunch_3": t("pk_1800_lunch_3"),
            "pk_1800_lunch_4": t("pk_1800_lunch_4"),
            "pk_1800_lunch_5": t("pk_1800_lunch_5"),
            "pk_1800_lunch_6": t("pk_1800_lunch_6"),
            "pk_1800_lunch_7": t("pk_1800_lunch_7")
        },
        "snack": {
            "pk_1800_snack_1": t("pk_1800_snack_1"),
            "pk_1800_snack_2": t("pk_1800_snack_2"),
            "pk_1800_snack_3": t("pk_1800_snack_3"),
            "pk_1800_snack_4": t("pk_1800_snack_4"),
            "pk_1800_snack_5": t("pk_1800_snack_5"),
            "pk_1800_snack_6": t("pk_1800_snack_6"),
            "pk_1800_snack_7": t("pk_1800_snack_7")
        },
        "dinner": {
            "pk_1800_dinner_1": t("pk_1800_dinner_1"),
            "pk_1800_dinner_2": t("pk_1800_dinner_2"),
            "pk_1800_dinner_3": t("pk_1800_dinner_3"),
            "pk_1800_dinner_4": t("pk_1800_dinner_4"),
            "pk_1800_dinner_5": t("pk_1800_dinner_5"),
            "pk_1800_dinner_6": t("pk_1800_dinner_6"),
            "pk_1800_dinner_7": t("pk_1800_dinner_7")
        }
    },
    "PittaKapha_2000": {
        "mdt": {
            "pk_2000_mdt_1": t("pk_2000_mdt_1"),
            "pk_2000_mdt_2": t("pk_2000_mdt_2"),
            "pk_2000_mdt_3": t("pk_2000_mdt_3"),
            "pk_2000_mdt_4": t("pk_2000_mdt_4"),
            "pk_2000_mdt_5": t("pk_2000_mdt_5"),
            "pk_2000_mdt_6": t("pk_2000_mdt_6"),
            "pk_2000_mdt_7": t("pk_2000_mdt_7")
        },
        "mbf": {
            "pk_2000_mbf_1": t("pk_2000_mbf_1"),
            "pk_2000_mbf_2": t("pk_2000_mbf_2"),
            "pk_2000_mbf_3": t("pk_2000_mbf_3"),
            "pk_2000_mbf_4": t("pk_2000_mbf_4"),
            "pk_2000_mbf_5": t("pk_2000_mbf_5"),
            "pk_2000_mbf_6": t("pk_2000_mbf_6"),
            "pk_2000_mbf_7": t("pk_2000_mbf_7")
        },
        "mmb": {
            "pk_2000_mmb_1": t("pk_2000_mmb_1"),
            "pk_2000_mmb_2": t("pk_2000_mmb_2"),
            "pk_2000_mmb_3": t("pk_2000_mmb_3"),
            "pk_2000_mmb_4": t("pk_2000_mmb_4"),
            "pk_2000_mmb_5": t("pk_2000_mmb_5"),
            "pk_2000_mmb_6": t("pk_2000_mmb_6"),
            "pk_2000_mmb_7": t("pk_2000_mmb_7")
        },
        "lunch": {
            "pk_2000_lunch_1": t("pk_2000_lunch_1"),
            "pk_2000_lunch_2": t("pk_2000_lunch_2"),
            "pk_2000_lunch_3": t("pk_2000_lunch_3"),
            "pk_2000_lunch_4": t("pk_2000_lunch_4"),
            "pk_2000_lunch_5": t("pk_2000_lunch_5"),
            "pk_2000_lunch_6": t("pk_2000_lunch_6"),
            "pk_2000_lunch_7": t("pk_2000_lunch_7")
        },
        "snack": {
            "pk_2000_snack_1": t("pk_2000_snack_1"),
            "pk_2000_snack_2": t("pk_2000_snack_2"),
            "pk_2000_snack_3": t("pk_2000_snack_3"),
            "pk_2000_snack_4": t("pk_2000_snack_4"),
            "pk_2000_snack_5": t("pk_2000_snack_5"),
            "pk_2000_snack_6": t("pk_2000_snack_6"),
            "pk_2000_snack_7": t("pk_2000_snack_7")
        },
        "dinner": {
            "pk_2000_dinner_1": t("pk_2000_dinner_1"),
            "pk_2000_dinner_2": t("pk_2000_dinner_2"),
            "pk_2000_dinner_3": t("pk_2000_dinner_3"),
            "pk_2000_dinner_4": t("pk_2000_dinner_4"),
            "pk_2000_dinner_5": t("pk_2000_dinner_5"),
            "pk_2000_dinner_6": t("pk_2000_dinner_6"),
            "pk_2000_dinner_7": t("pk_2000_dinner_7")
        }
    },
    "PittaKapha_2200": {
        "mdt": {
            "pk_2200_mdt_1": t("pk_2200_mdt_1"),
            "pk_2200_mdt_2": t("pk_2200_mdt_2"),
            "pk_2200_mdt_3": t("pk_2200_mdt_3"),
            "pk_2200_mdt_4": t("pk_2200_mdt_4"),
            "pk_2200_mdt_5": t("pk_2200_mdt_5"),
            "pk_2200_mdt_6": t("pk_2200_mdt_6"),
            "pk_2200_mdt_7": t("pk_2200_mdt_7")
        },
        "mbf": {
            "pk_2200_mbf_1": t("pk_2200_mbf_1"),
            "pk_2200_mbf_2": t("pk_2200_mbf_2"),
            "pk_2200_mbf_3": t("pk_2200_mbf_3"),
            "pk_2200_mbf_4": t("pk_2200_mbf_4"),
            "pk_2200_mbf_5": t("pk_2200_mbf_5"),
            "pk_2200_mbf_6": t("pk_2200_mbf_6"),
            "pk_2200_mbf_7": t("pk_2200_mbf_7")
        },
        "mmb": {
            "pk_2200_mmb_1": t("pk_2200_mmb_1"),
            "pk_2200_mmb_2": t("pk_2200_mmb_2"),
            "pk_2200_mmb_3": t("pk_2200_mmb_3"),
            "pk_2200_mmb_4": t("pk_2200_mmb_4"),
            "pk_2200_mmb_5": t("pk_2200_mmb_5"),
            "pk_2200_mmb_6": t("pk_2200_mmb_6"),
            "pk_2200_mmb_7": t("pk_2200_mmb_7")
        },
        "lunch": {
            "pk_2200_lunch_1": t("pk_2200_lunch_1"),
            "pk_2200_lunch_2": t("pk_2200_lunch_2"),
            "pk_2200_lunch_3": t("pk_2200_lunch_3"),
            "pk_2200_lunch_4": t("pk_2200_lunch_4"),
            "pk_2200_lunch_5": t("pk_2200_lunch_5"),
            "pk_2200_lunch_6": t("pk_2200_lunch_6"),
            "pk_2200_lunch_7": t("pk_2200_lunch_7")
        },
        "snack": {
            "pk_2200_snack_1": t("pk_2200_snack_1"),
            "pk_2200_snack_2": t("pk_2200_snack_2"),
            "pk_2200_snack_3": t("pk_2200_snack_3"),
            "pk_2200_snack_4": t("pk_2200_snack_4"),
            "pk_2200_snack_5": t("pk_2200_snack_5"),
            "pk_2200_snack_6": t("pk_2200_snack_6"),
            "pk_2200_snack_7": t("pk_2200_snack_7")
        },
        "dinner": {
            "pk_2200_dinner_1": t("pk_2200_dinner_1"),
            "pk_2200_dinner_2": t("pk_2200_dinner_2"),
            "pk_2200_dinner_3": t("pk_2200_dinner_3"),
            "pk_2200_dinner_4": t("pk_2200_dinner_4"),
            "pk_2200_dinner_5": t("pk_2200_dinner_5"),
            "pk_2200_dinner_6": t("pk_2200_dinner_6"),
            "pk_2200_dinner_7": t("pk_2200_dinner_7")
        }
    },
    "PittaKapha_2400": {
        "mdt": {
            "pk_2400_mdt_1": t("pk_2400_mdt_1"),
            "pk_2400_mdt_2": t("pk_2400_mdt_2"),
            "pk_2400_mdt_3": t("pk_2400_mdt_3"),
            "pk_2400_mdt_4": t("pk_2400_mdt_4"),
            "pk_2400_mdt_5": t("pk_2400_mdt_5"),
            "pk_2400_mdt_6": t("pk_2400_mdt_6"),
            "pk_2400_mdt_7": t("pk_2400_mdt_7")
        },
        "mbf": {
            "pk_2400_mbf_1": t("pk_2400_mbf_1"),
            "pk_2400_mbf_2": t("pk_2400_mbf_2"),
            "pk_2400_mbf_3": t("pk_2400_mbf_3"),
            "pk_2400_mbf_4": t("pk_2400_mbf_4"),
            "pk_2400_mbf_5": t("pk_2400_mbf_5"),
            "pk_2400_mbf_6": t("pk_2400_mbf_6"),
            "pk_2400_mbf_7": t("pk_2400_mbf_7")
        },
        "mmb": {
            "pk_2400_mmb_1": t("pk_2400_mmb_1"),
            "pk_2400_mmb_2": t("pk_2400_mmb_2"),
            "pk_2400_mmb_3": t("pk_2400_mmb_3"),
            "pk_2400_mmb_4": t("pk_2400_mmb_4"),
            "pk_2400_mmb_5": t("pk_2400_mmb_5"),
            "pk_2400_mmb_6": t("pk_2400_mmb_6"),
            "pk_2400_mmb_7": t("pk_2400_mmb_7")
        },
        "lunch": {
            "pk_2400_lunch_1": t("pk_2400_lunch_1"),
            "pk_2400_lunch_2": t("pk_2400_lunch_2"),
            "pk_2400_lunch_3": t("pk_2400_lunch_3"),
            "pk_2400_lunch_4": t("pk_2400_lunch_4"),
            "pk_2400_lunch_5": t("pk_2400_lunch_5"),
            "pk_2400_lunch_6": t("pk_2400_lunch_6"),
            "pk_2400_lunch_7": t("pk_2400_lunch_7")
        },
        "snack": {
            "pk_2400_snack_1": t("pk_2400_snack_1"),
            "pk_2400_snack_2": t("pk_2400_snack_2"),
            "pk_2400_snack_3": t("pk_2400_snack_3"),
            "pk_2400_snack_4": t("pk_2400_snack_4"),
            "pk_2400_snack_5": t("pk_2400_snack_5"),
            "pk_2400_snack_6": t("pk_2400_snack_6"),
            "pk_2400_snack_7": t("pk_2400_snack_7")
        },
        "dinner": {
            "pk_2400_dinner_1": t("pk_2400_dinner_1"),
            "pk_2400_dinner_2": t("pk_2400_dinner_2"),
            "pk_2400_dinner_3": t("pk_2400_dinner_3"),
            "pk_2400_dinner_4": t("pk_2400_dinner_4"),
            "pk_2400_dinner_5": t("pk_2400_dinner_5"),
            "pk_2400_dinner_6": t("pk_2400_dinner_6"),
            "pk_2400_dinner_7": t("pk_2400_dinner_7")
        }
    },
    "PittaKapha_2600": {
        "mdt": {
            "pk_2600_mdt_1": t("pk_2600_mdt_1"),
            "pk_2600_mdt_2": t("pk_2600_mdt_2"),
            "pk_2600_mdt_3": t("pk_2600_mdt_3"),
            "pk_2600_mdt_4": t("pk_2600_mdt_4"),
            "pk_2600_mdt_5": t("pk_2600_mdt_5"),
            "pk_2600_mdt_6": t("pk_2600_mdt_6"),
            "pk_2600_mdt_7": t("pk_2600_mdt_7")
        },
        "mbf": {
            "pk_2600_mbf_1": t("pk_2600_mbf_1"),
            "pk_2600_mbf_2": t("pk_2600_mbf_2"),
            "pk_2600_mbf_3": t("pk_2600_mbf_3"),
            "pk_2600_mbf_4": t("pk_2600_mbf_4"),
            "pk_2600_mbf_5": t("pk_2600_mbf_5"),
            "pk_2600_mbf_6": t("pk_2600_mbf_6"),
            "pk_2600_mbf_7": t("pk_2600_mbf_7")
        },
        "mmb": {
            "pk_2600_mmb_1": t("pk_2600_mmb_1"),
            "pk_2600_mmb_2": t("pk_2600_mmb_2"),
            "pk_2600_mmb_3": t("pk_2600_mmb_3"),
            "pk_2600_mmb_4": t("pk_2600_mmb_4"),
            "pk_2600_mmb_5": t("pk_2600_mmb_5"),
            "pk_2600_mmb_6": t("pk_2600_mmb_6"),
            "pk_2600_mmb_7": t("pk_2600_mmb_7")
        },
        "lunch": {
            "pk_2600_lunch_1": t("pk_2600_lunch_1"),
            "pk_2600_lunch_2": t("pk_2600_lunch_2"),
            "pk_2600_lunch_3": t("pk_2600_lunch_3"),
            "pk_2600_lunch_4": t("pk_2600_lunch_4"),
            "pk_2600_lunch_5": t("pk_2600_lunch_5"),
            "pk_2600_lunch_6": t("pk_2600_lunch_6"),
            "pk_2600_lunch_7": t("pk_2600_lunch_7")
        },
        "snack": {
            "pk_2600_snack_1": t("pk_2600_snack_1"),
            "pk_2600_snack_2": t("pk_2600_snack_2"),
            "pk_2600_snack_3": t("pk_2600_snack_3"),
            "pk_2600_snack_4": t("pk_2600_snack_4"),
            "pk_2600_snack_5": t("pk_2600_snack_5"),
            "pk_2600_snack_6": t("pk_2600_snack_6"),
            "pk_2600_snack_7": t("pk_2600_snack_7")
        },
        "dinner": {
            "pk_2600_dinner_1": t("pk_2600_dinner_1"),
            "pk_2600_dinner_2": t("pk_2600_dinner_2"),
            "pk_2600_dinner_3": t("pk_2600_dinner_3"),
            "pk_2600_dinner_4": t("pk_2600_dinner_4"),
            "pk_2600_dinner_5": t("pk_2600_dinner_5"),
            "pk_2600_dinner_6": t("pk_2600_dinner_6"),
            "pk_2600_dinner_7": t("pk_2600_dinner_7")
        }
    },
    "PittaKapha_2800": {
        "mdt": {
            "pk_2800_mdt_1": t("pk_2800_mdt_1"),
            "pk_2800_mdt_2": t("pk_2800_mdt_2"),
            "pk_2800_mdt_3": t("pk_2800_mdt_3"),
            "pk_2800_mdt_4": t("pk_2800_mdt_4"),
            "pk_2800_mdt_5": t("pk_2800_mdt_5"),
            "pk_2800_mdt_6": t("pk_2800_mdt_6"),
            "pk_2800_mdt_7": t("pk_2800_mdt_7")
        },
        "mbf": {
            "pk_2800_mbf_1": t("pk_2800_mbf_1"),
            "pk_2800_mbf_2": t("pk_2800_mbf_2"),
            "pk_2800_mbf_3": t("pk_2800_mbf_3"),
            "pk_2800_mbf_4": t("pk_2800_mbf_4"),
            "pk_2800_mbf_5": t("pk_2800_mbf_5"),
            "pk_2800_mbf_6": t("pk_2800_mbf_6"),
            "pk_2800_mbf_7": t("pk_2800_mbf_7")
        },
        "mmb": {
            "pk_2800_mmb_1": t("pk_2800_mmb_1"),
            "pk_2800_mmb_2": t("pk_2800_mmb_2"),
            "pk_2800_mmb_3": t("pk_2800_mmb_3"),
            "pk_2800_mmb_4": t("pk_2800_mmb_4"),
            "pk_2800_mmb_5": t("pk_2800_mmb_5"),
            "pk_2800_mmb_6": t("pk_2800_mmb_6"),
            "pk_2800_mmb_7": t("pk_2800_mmb_7")
        },
        "lunch": {
            "pk_2800_lunch_1": t("pk_2800_lunch_1"),
            "pk_2800_lunch_2": t("pk_2800_lunch_2"),
            "pk_2800_lunch_3": t("pk_2800_lunch_3"),
            "pk_2800_lunch_4": t("pk_2800_lunch_4"),
            "pk_2800_lunch_5": t("pk_2800_lunch_5"),
            "pk_2800_lunch_6": t("pk_2800_lunch_6"),
            "pk_2800_lunch_7": t("pk_2800_lunch_7")
        },
        "snack": {
            "pk_2800_snack_1": t("pk_2800_snack_1"),
            "pk_2800_snack_2": t("pk_2800_snack_2"),
            "pk_2800_snack_3": t("pk_2800_snack_3"),
            "pk_2800_snack_4": t("pk_2800_snack_4"),
            "pk_2800_snack_5": t("pk_2800_snack_5"),
            "pk_2800_snack_6": t("pk_2800_snack_6"),
            "pk_2800_snack_7": t("pk_2800_snack_7")
        },
        "dinner": {
            "pk_2800_dinner_1": t("pk_2800_dinner_1"),
            "pk_2800_dinner_2": t("pk_2800_dinner_2"),
            "pk_2800_dinner_3": t("pk_2800_dinner_3"),
            "pk_2800_dinner_4": t("pk_2800_dinner_4"),
            "pk_2800_dinner_5": t("pk_2800_dinner_5"),
            "pk_2800_dinner_6": t("pk_2800_dinner_6"),
            "pk_2800_dinner_7": t("pk_2800_dinner_7")
        }
    },
    "PittaKapha_3000": {
        "mdt": {
            "pk_3000_mdt_1": t("pk_3000_mdt_1"),
            "pk_3000_mdt_2": t("pk_3000_mdt_2"),
            "pk_3000_mdt_3": t("pk_3000_mdt_3"),
            "pk_3000_mdt_4": t("pk_3000_mdt_4"),
            "pk_3000_mdt_5": t("pk_3000_mdt_5"),
            "pk_3000_mdt_6": t("pk_3000_mdt_6"),
            "pk_3000_mdt_7": t("pk_3000_mdt_7")
        },
        "mbf": {
            "pk_3000_mbf_1": t("pk_3000_mbf_1"),
            "pk_3000_mbf_2": t("pk_3000_mbf_2"),
            "pk_3000_mbf_3": t("pk_3000_mbf_3"),
            "pk_3000_mbf_4": t("pk_3000_mbf_4"),
            "pk_3000_mbf_5": t("pk_3000_mbf_5"),
            "pk_3000_mbf_6": t("pk_3000_mbf_6"),
            "pk_3000_mbf_7": t("pk_3000_mbf_7")
        },
        "mmb": {
            "pk_3000_mmb_1": t("pk_3000_mmb_1"),
            "pk_3000_mmb_2": t("pk_3000_mmb_2"),
            "pk_3000_mmb_3": t("pk_3000_mmb_3"),
            "pk_3000_mmb_4": t("pk_3000_mmb_4"),
            "pk_3000_mmb_5": t("pk_3000_mmb_5"),
            "pk_3000_mmb_6": t("pk_3000_mmb_6"),
            "pk_3000_mmb_7": t("pk_3000_mmb_7")
        },
        "lunch": {
            "pk_3000_lunch_1": t("pk_3000_lunch_1"),
            "pk_3000_lunch_2": t("pk_3000_lunch_2"),
            "pk_3000_lunch_3": t("pk_3000_lunch_3"),
            "pk_3000_lunch_4": t("pk_3000_lunch_4"),
            "pk_3000_lunch_5": t("pk_3000_lunch_5"),
            "pk_3000_lunch_6": t("pk_3000_lunch_6"),
            "pk_3000_lunch_7": t("pk_3000_lunch_7")
        },
        "snack": {
            "pk_3000_snack_1": t("pk_3000_snack_1"),
            "pk_3000_snack_2": t("pk_3000_snack_2"),
            "pk_3000_snack_3": t("pk_3000_snack_3"),
            "pk_3000_snack_4": t("pk_3000_snack_4"),
            "pk_3000_snack_5": t("pk_3000_snack_5"),
            "pk_3000_snack_6": t("pk_3000_snack_6"),
            "pk_3000_snack_7": t("pk_3000_snack_7")
        },
        "dinner": {
            "pk_3000_dinner_1": t("pk_3000_dinner_1"),
            "pk_3000_dinner_2": t("pk_3000_dinner_2"),
            "pk_3000_dinner_3": t("pk_3000_dinner_3"),
            "pk_3000_dinner_4": t("pk_3000_dinner_4"),
            "pk_3000_dinner_5": t("pk_3000_dinner_5"),
            "pk_3000_dinner_6": t("pk_3000_dinner_6"),
            "pk_3000_dinner_7": t("pk_3000_dinner_7")
        }
    },


    "KaphaVata_1800": {
        "mdt": {
            "kv_1800_mdt_1": t("kv_1800_mdt_1"),
            "kv_1800_mdt_2": t("kv_1800_mdt_2"),
            "kv_1800_mdt_3": t("kv_1800_mdt_3"),
            "kv_1800_mdt_4": t("kv_1800_mdt_4"),
            "kv_1800_mdt_5": t("kv_1800_mdt_5"),
            "kv_1800_mdt_6": t("kv_1800_mdt_6"),
            "kv_1800_mdt_7": t("kv_1800_mdt_7")
        },
        "mbf": {
            "kv_1800_mbf_1": t("kv_1800_mbf_1"),
            "kv_1800_mbf_2": t("kv_1800_mbf_2"),
            "kv_1800_mbf_3": t("kv_1800_mbf_3"),
            "kv_1800_mbf_4": t("kv_1800_mbf_4"),
            "kv_1800_mbf_5": t("kv_1800_mbf_5"),
            "kv_1800_mbf_6": t("kv_1800_mbf_6"),
            "kv_1800_mbf_7": t("kv_1800_mbf_7")
        },
        "mmb": {
            "kv_1800_mmb_1": t("kv_1800_mmb_1"),
            "kv_1800_mmb_2": t("kv_1800_mmb_2"),
            "kv_1800_mmb_3": t("kv_1800_mmb_3"),
            "kv_1800_mmb_4": t("kv_1800_mmb_4"),
            "kv_1800_mmb_5": t("kv_1800_mmb_5"),
            "kv_1800_mmb_6": t("kv_1800_mmb_6"),
            "kv_1800_mmb_7": t("kv_1800_mmb_7")
        },
        "lunch": {
            "kv_1800_lunch_1": t("kv_1800_lunch_1"),
            "kv_1800_lunch_2": t("kv_1800_lunch_2"),
            "kv_1800_lunch_3": t("kv_1800_lunch_3"),
            "kv_1800_lunch_4": t("kv_1800_lunch_4"),
            "kv_1800_lunch_5": t("kv_1800_lunch_5"),
            "kv_1800_lunch_6": t("kv_1800_lunch_6"),
            "kv_1800_lunch_7": t("kv_1800_lunch_7")
        },
        "snack": {
            "kv_1800_snack_1": t("kv_1800_snack_1"),
            "kv_1800_snack_2": t("kv_1800_snack_2"),
            "kv_1800_snack_3": t("kv_1800_snack_3"),
            "kv_1800_snack_4": t("kv_1800_snack_4"),
            "kv_1800_snack_5": t("kv_1800_snack_5"),
            "kv_1800_snack_6": t("kv_1800_snack_6"),
            "kv_1800_snack_7": t("kv_1800_snack_7")
        },
        "dinner": {
            "kv_1800_dinner_1": t("kv_1800_dinner_1"),
            "kv_1800_dinner_2": t("kv_1800_dinner_2"),
            "kv_1800_dinner_3": t("kv_1800_dinner_3"),
            "kv_1800_dinner_4": t("kv_1800_dinner_4"),
            "kv_1800_dinner_5": t("kv_1800_dinner_5"),
            "kv_1800_dinner_6": t("kv_1800_dinner_6"),
            "kv_1800_dinner_7": t("kv_1800_dinner_7")
        }
    },
    "KaphaVata_2000": {
        "mdt": {
            "kv_2000_mdt_1": t("kv_2000_mdt_1"),
            "kv_2000_mdt_2": t("kv_2000_mdt_2"),
            "kv_2000_mdt_3": t("kv_2000_mdt_3"),
            "kv_2000_mdt_4": t("kv_2000_mdt_4"),
            "kv_2000_mdt_5": t("kv_2000_mdt_5"),
            "kv_2000_mdt_6": t("kv_2000_mdt_6"),
            "kv_2000_mdt_7": t("kv_2000_mdt_7")
        },
        "mbf": {
            "kv_2000_mbf_1": t("kv_2000_mbf_1"),
            "kv_2000_mbf_2": t("kv_2000_mbf_2"),
            "kv_2000_mbf_3": t("kv_2000_mbf_3"),
            "kv_2000_mbf_4": t("kv_2000_mbf_4"),
            "kv_2000_mbf_5": t("kv_2000_mbf_5"),
            "kv_2000_mbf_6": t("kv_2000_mbf_6"),
            "kv_2000_mbf_7": t("kv_2000_mbf_7")
        },
        "mmb": {
            "kv_2000_mmb_1": t("kv_2000_mmb_1"),
            "kv_2000_mmb_2": t("kv_2000_mmb_2"),
            "kv_2000_mmb_3": t("kv_2000_mmb_3"),
            "kv_2000_mmb_4": t("kv_2000_mmb_4"),
            "kv_2000_mmb_5": t("kv_2000_mmb_5"),
            "kv_2000_mmb_6": t("kv_2000_mmb_6"),
            "kv_2000_mmb_7": t("kv_2000_mmb_7")
        },
        "lunch": {
            "kv_2000_lunch_1": t("kv_2000_lunch_1"),
            "kv_2000_lunch_2": t("kv_2000_lunch_2"),
            "kv_2000_lunch_3": t("kv_2000_lunch_3"),
            "kv_2000_lunch_4": t("kv_2000_lunch_4"),
            "kv_2000_lunch_5": t("kv_2000_lunch_5"),
            "kv_2000_lunch_6": t("kv_2000_lunch_6"),
            "kv_2000_lunch_7": t("kv_2000_lunch_7")
        },
        "snack": {
            "kv_2000_snack_1": t("kv_2000_snack_1"),
            "kv_2000_snack_2": t("kv_2000_snack_2"),
            "kv_2000_snack_3": t("kv_2000_snack_3"),
            "kv_2000_snack_4": t("kv_2000_snack_4"),
            "kv_2000_snack_5": t("kv_2000_snack_5"),
            "kv_2000_snack_6": t("kv_2000_snack_6"),
            "kv_2000_snack_7": t("kv_2000_snack_7")
        },
        "dinner": {
            "kv_2000_dinner_1": t("kv_2000_dinner_1"),
            "kv_2000_dinner_2": t("kv_2000_dinner_2"),
            "kv_2000_dinner_3": t("kv_2000_dinner_3"),
            "kv_2000_dinner_4": t("kv_2000_dinner_4"),
            "kv_2000_dinner_5": t("kv_2000_dinner_5"),
            "kv_2000_dinner_6": t("kv_2000_dinner_6"),
            "kv_2000_dinner_7": t("kv_2000_dinner_7")
        }
    },
    "KaphaVata_2200": {
        "mdt": {
            "kv_2200_mdt_1": t("kv_2200_mdt_1"),
            "kv_2200_mdt_2": t("kv_2200_mdt_2"),
            "kv_2200_mdt_3": t("kv_2200_mdt_3"),
            "kv_2200_mdt_4": t("kv_2200_mdt_4"),
            "kv_2200_mdt_5": t("kv_2200_mdt_5"),
            "kv_2200_mdt_6": t("kv_2200_mdt_6"),
            "kv_2200_mdt_7": t("kv_2200_mdt_7")
        },
        "mbf": {
            "kv_2200_mbf_1": t("kv_2200_mbf_1"),
            "kv_2200_mbf_2": t("kv_2200_mbf_2"),
            "kv_2200_mbf_3": t("kv_2200_mbf_3"),
            "kv_2200_mbf_4": t("kv_2200_mbf_4"),
            "kv_2200_mbf_5": t("kv_2200_mbf_5"),
            "kv_2200_mbf_6": t("kv_2200_mbf_6"),
            "kv_2200_mbf_7": t("kv_2200_mbf_7")
        },
        "mmb": {
            "kv_2200_mmb_1": t("kv_2200_mmb_1"),
            "kv_2200_mmb_2": t("kv_2200_mmb_2"),
            "kv_2200_mmb_3": t("kv_2200_mmb_3"),
            "kv_2200_mmb_4": t("kv_2200_mmb_4"),
            "kv_2200_mmb_5": t("kv_2200_mmb_5"),
            "kv_2200_mmb_6": t("kv_2200_mmb_6"),
            "kv_2200_mmb_7": t("kv_2200_mmb_7")
        },
        "lunch": {
            "kv_2200_lunch_1": t("kv_2200_lunch_1"),
            "kv_2200_lunch_2": t("kv_2200_lunch_2"),
            "kv_2200_lunch_3": t("kv_2200_lunch_3"),
            "kv_2200_lunch_4": t("kv_2200_lunch_4"),
            "kv_2200_lunch_5": t("kv_2200_lunch_5"),
            "kv_2200_lunch_6": t("kv_2200_lunch_6"),
            "kv_2200_lunch_7": t("kv_2200_lunch_7")
        },
        "snack": {
            "kv_2200_snack_1": t("kv_2200_snack_1"),
            "kv_2200_snack_2": t("kv_2200_snack_2"),
            "kv_2200_snack_3": t("kv_2200_snack_3"),
            "kv_2200_snack_4": t("kv_2200_snack_4"),
            "kv_2200_snack_5": t("kv_2200_snack_5"),
            "kv_2200_snack_6": t("kv_2200_snack_6"),
            "kv_2200_snack_7": t("kv_2200_snack_7")
        },
        "dinner": {
            "kv_2200_dinner_1": t("kv_2200_dinner_1"),
            "kv_2200_dinner_2": t("kv_2200_dinner_2"),
            "kv_2200_dinner_3": t("kv_2200_dinner_3"),
            "kv_2200_dinner_4": t("kv_2200_dinner_4"),
            "kv_2200_dinner_5": t("kv_2200_dinner_5"),
            "kv_2200_dinner_6": t("kv_2200_dinner_6"),
            "kv_2200_dinner_7": t("kv_2200_dinner_7")
        }
    },
    "KaphaVata_2400": {
        "mdt": {
            "kv_2400_mdt_1": t("kv_2400_mdt_1"),
            "kv_2400_mdt_2": t("kv_2400_mdt_2"),
            "kv_2400_mdt_3": t("kv_2400_mdt_3"),
            "kv_2400_mdt_4": t("kv_2400_mdt_4"),
            "kv_2400_mdt_5": t("kv_2400_mdt_5"),
            "kv_2400_mdt_6": t("kv_2400_mdt_6"),
            "kv_2400_mdt_7": t("kv_2400_mdt_7")
        },
        "mbf": {
            "kv_2400_mbf_1": t("kv_2400_mbf_1"),
            "kv_2400_mbf_2": t("kv_2400_mbf_2"),
            "kv_2400_mbf_3": t("kv_2400_mbf_3"),
            "kv_2400_mbf_4": t("kv_2400_mbf_4"),
            "kv_2400_mbf_5": t("kv_2400_mbf_5"),
            "kv_2400_mbf_6": t("kv_2400_mbf_6"),
            "kv_2400_mbf_7": t("kv_2400_mbf_7")
        },
        "mmb": {
            "kv_2400_mmb_1": t("kv_2400_mmb_1"),
            "kv_2400_mmb_2": t("kv_2400_mmb_2"),
            "kv_2400_mmb_3": t("kv_2400_mmb_3"),
            "kv_2400_mmb_4": t("kv_2400_mmb_4"),
            "kv_2400_mmb_5": t("kv_2400_mmb_5"),
            "kv_2400_mmb_6": t("kv_2400_mmb_6"),
            "kv_2400_mmb_7": t("kv_2400_mmb_7")
        },
        "lunch": {
            "kv_2400_lunch_1": t("kv_2400_lunch_1"),
            "kv_2400_lunch_2": t("kv_2400_lunch_2"),
            "kv_2400_lunch_3": t("kv_2400_lunch_3"),
            "kv_2400_lunch_4": t("kv_2400_lunch_4"),
            "kv_2400_lunch_5": t("kv_2400_lunch_5"),
            "kv_2400_lunch_6": t("kv_2400_lunch_6"),
            "kv_2400_lunch_7": t("kv_2400_lunch_7")
        },
        "snack": {
            "kv_2400_snack_1": t("kv_2400_snack_1"),
            "kv_2400_snack_2": t("kv_2400_snack_2"),
            "kv_2400_snack_3": t("kv_2400_snack_3"),
            "kv_2400_snack_4": t("kv_2400_snack_4"),
            "kv_2400_snack_5": t("kv_2400_snack_5"),
            "kv_2400_snack_6": t("kv_2400_snack_6"),
            "kv_2400_snack_7": t("kv_2400_snack_7")
        },
        "dinner": {
            "kv_2400_dinner_1": t("kv_2400_dinner_1"),
            "kv_2400_dinner_2": t("kv_2400_dinner_2"),
            "kv_2400_dinner_3": t("kv_2400_dinner_3"),
            "kv_2400_dinner_4": t("kv_2400_dinner_4"),
            "kv_2400_dinner_5": t("kv_2400_dinner_5"),
            "kv_2400_dinner_6": t("kv_2400_dinner_6"),
            "kv_2400_dinner_7": t("kv_2400_dinner_7")
        }
    },
    "KaphaVata_2600": {
        "mdt": {
            "kv_2600_mdt_1": t("kv_2600_mdt_1"),
            "kv_2600_mdt_2": t("kv_2600_mdt_2"),
            "kv_2600_mdt_3": t("kv_2600_mdt_3"),
            "kv_2600_mdt_4": t("kv_2600_mdt_4"),
            "kv_2600_mdt_5": t("kv_2600_mdt_5"),
            "kv_2600_mdt_6": t("kv_2600_mdt_6"),
            "kv_2600_mdt_7": t("kv_2600_mdt_7")
        },
        "mbf": {
            "kv_2600_mbf_1": t("kv_2600_mbf_1"),
            "kv_2600_mbf_2": t("kv_2600_mbf_2"),
            "kv_2600_mbf_3": t("kv_2600_mbf_3"),
            "kv_2600_mbf_4": t("kv_2600_mbf_4"),
            "kv_2600_mbf_5": t("kv_2600_mbf_5"),
            "kv_2600_mbf_6": t("kv_2600_mbf_6"),
            "kv_2600_mbf_7": t("kv_2600_mbf_7")
        },
        "mmb": {
            "kv_2600_mmb_1": t("kv_2600_mmb_1"),
            "kv_2600_mmb_2": t("kv_2600_mmb_2"),
            "kv_2600_mmb_3": t("kv_2600_mmb_3"),
            "kv_2600_mmb_4": t("kv_2600_mmb_4"),
            "kv_2600_mmb_5": t("kv_2600_mmb_5"),
            "kv_2600_mmb_6": t("kv_2600_mmb_6"),
            "kv_2600_mmb_7": t("kv_2600_mmb_7")
        },
        "lunch": {
            "kv_2600_lunch_1": t("kv_2600_lunch_1"),
            "kv_2600_lunch_2": t("kv_2600_lunch_2"),
            "kv_2600_lunch_3": t("kv_2600_lunch_3"),
            "kv_2600_lunch_4": t("kv_2600_lunch_4"),
            "kv_2600_lunch_5": t("kv_2600_lunch_5"),
            "kv_2600_lunch_6": t("kv_2600_lunch_6"),
            "kv_2600_lunch_7": t("kv_2600_lunch_7")
        },
        "snack": {
            "kv_2600_snack_1": t("kv_2600_snack_1"),
            "kv_2600_snack_2": t("kv_2600_snack_2"),
            "kv_2600_snack_3": t("kv_2600_snack_3"),
            "kv_2600_snack_4": t("kv_2600_snack_4"),
            "kv_2600_snack_5": t("kv_2600_snack_5"),
            "kv_2600_snack_6": t("kv_2600_snack_6"),
            "kv_2600_snack_7": t("kv_2600_snack_7")
        },
        "dinner": {
            "kv_2600_dinner_1": t("kv_2600_dinner_1"),
            "kv_2600_dinner_2": t("kv_2600_dinner_2"),
            "kv_2600_dinner_3": t("kv_2600_dinner_3"),
            "kv_2600_dinner_4": t("kv_2600_dinner_4"),
            "kv_2600_dinner_5": t("kv_2600_dinner_5"),
            "kv_2600_dinner_6": t("kv_2600_dinner_6"),
            "kv_2600_dinner_7": t("kv_2600_dinner_7")
        }
    },
    "KaphaVata_2800": {
        "mdt": {
            "kv_2800_mdt_1": t("kv_2800_mdt_1"),
            "kv_2800_mdt_2": t("kv_2800_mdt_2"),
            "kv_2800_mdt_3": t("kv_2800_mdt_3"),
            "kv_2800_mdt_4": t("kv_2800_mdt_4"),
            "kv_2800_mdt_5": t("kv_2800_mdt_5"),
            "kv_2800_mdt_6": t("kv_2800_mdt_6"),
            "kv_2800_mdt_7": t("kv_2800_mdt_7")
        },
        "mbf": {
            "kv_2800_mbf_1": t("kv_2800_mbf_1"),
            "kv_2800_mbf_2": t("kv_2800_mbf_2"),
            "kv_2800_mbf_3": t("kv_2800_mbf_3"),
            "kv_2800_mbf_4": t("kv_2800_mbf_4"),
            "kv_2800_mbf_5": t("kv_2800_mbf_5"),
            "kv_2800_mbf_6": t("kv_2800_mbf_6"),
            "kv_2800_mbf_7": t("kv_2800_mbf_7")
        },
        "mmb": {
            "kv_2800_mmb_1": t("kv_2800_mmb_1"),
            "kv_2800_mmb_2": t("kv_2800_mmb_2"),
            "kv_2800_mmb_3": t("kv_2800_mmb_3"),
            "kv_2800_mmb_4": t("kv_2800_mmb_4"),
            "kv_2800_mmb_5": t("kv_2800_mmb_5"),
            "kv_2800_mmb_6": t("kv_2800_mmb_6"),
            "kv_2800_mmb_7": t("kv_2800_mmb_7")
        },
        "lunch": {
            "kv_2800_lunch_1": t("kv_2800_lunch_1"),
            "kv_2800_lunch_2": t("kv_2800_lunch_2"),
            "kv_2800_lunch_3": t("kv_2800_lunch_3"),
            "kv_2800_lunch_4": t("kv_2800_lunch_4"),
            "kv_2800_lunch_5": t("kv_2800_lunch_5"),
            "kv_2800_lunch_6": t("kv_2800_lunch_6"),
            "kv_2800_lunch_7": t("kv_2800_lunch_7")
        },
        "snack": {
            "kv_2800_snack_1": t("kv_2800_snack_1"),
            "kv_2800_snack_2": t("kv_2800_snack_2"),
            "kv_2800_snack_3": t("kv_2800_snack_3"),
            "kv_2800_snack_4": t("kv_2800_snack_4"),
            "kv_2800_snack_5": t("kv_2800_snack_5"),
            "kv_2800_snack_6": t("kv_2800_snack_6"),
            "kv_2800_snack_7": t("kv_2800_snack_7")
        },
        "dinner": {
            "kv_2800_dinner_1": t("kv_2800_dinner_1"),
            "kv_2800_dinner_2": t("kv_2800_dinner_2"),
            "kv_2800_dinner_3": t("kv_2800_dinner_3"),
            "kv_2800_dinner_4": t("kv_2800_dinner_4"),
            "kv_2800_dinner_5": t("kv_2800_dinner_5"),
            "kv_2800_dinner_6": t("kv_2800_dinner_6"),
            "kv_2800_dinner_7": t("kv_2800_dinner_7")
        }
    },
    "KaphaVata_3000": {
        "mdt": {
            "kv_3000_mdt_1": t("kv_3000_mdt_1"),
            "kv_3000_mdt_2": t("kv_3000_mdt_2"),
            "kv_3000_mdt_3": t("kv_3000_mdt_3"),
            "kv_3000_mdt_4": t("kv_3000_mdt_4"),
            "kv_3000_mdt_5": t("kv_3000_mdt_5"),
            "kv_3000_mdt_6": t("kv_3000_mdt_6"),
            "kv_3000_mdt_7": t("kv_3000_mdt_7")
        },
        "mbf": {
            "kv_3000_mbf_1": t("kv_3000_mbf_1"),
            "kv_3000_mbf_2": t("kv_3000_mbf_2"),
            "kv_3000_mbf_3": t("kv_3000_mbf_3"),
            "kv_3000_mbf_4": t("kv_3000_mbf_4"),
            "kv_3000_mbf_5": t("kv_3000_mbf_5"),
            "kv_3000_mbf_6": t("kv_3000_mbf_6"),
            "kv_3000_mbf_7": t("kv_3000_mbf_7")
        },
        "mmb": {
            "kv_3000_mmb_1": t("kv_3000_mmb_1"),
            "kv_3000_mmb_2": t("kv_3000_mmb_2"),
            "kv_3000_mmb_3": t("kv_3000_mmb_3"),
            "kv_3000_mmb_4": t("kv_3000_mmb_4"),
            "kv_3000_mmb_5": t("kv_3000_mmb_5"),
            "kv_3000_mmb_6": t("kv_3000_mmb_6"),
            "kv_3000_mmb_7": t("kv_3000_mmb_7")
        },
        "lunch": {
            "kv_3000_lunch_1": t("kv_3000_lunch_1"),
            "kv_3000_lunch_2": t("kv_3000_lunch_2"),
            "kv_3000_lunch_3": t("kv_3000_lunch_3"),
            "kv_3000_lunch_4": t("kv_3000_lunch_4"),
            "kv_3000_lunch_5": t("kv_3000_lunch_5"),
            "kv_3000_lunch_6": t("kv_3000_lunch_6"),
            "kv_3000_lunch_7": t("kv_3000_lunch_7")
        },
        "snack": {
            "kv_3000_snack_1": t("kv_3000_snack_1"),
            "kv_3000_snack_2": t("kv_3000_snack_2"),
            "kv_3000_snack_3": t("kv_3000_snack_3"),
            "kv_3000_snack_4": t("kv_3000_snack_4"),
            "kv_3000_snack_5": t("kv_3000_snack_5"),
            "kv_3000_snack_6": t("kv_3000_snack_6"),
            "kv_3000_snack_7": t("kv_3000_snack_7")
        },
        "dinner": {
            "kv_3000_dinner_1": t("kv_3000_dinner_1"),
            "kv_3000_dinner_2": t("kv_3000_dinner_2"),
            "kv_3000_dinner_3": t("kv_3000_dinner_3"),
            "kv_3000_dinner_4": t("kv_3000_dinner_4"),
            "kv_3000_dinner_5": t("kv_3000_dinner_5"),
            "kv_3000_dinner_6": t("kv_3000_dinner_6"),
            "kv_3000_dinner_7": t("kv_3000_dinner_7")
        }
    },


    "KaphaPitta_1800": {
        "mdt": {
            "kp_1800_mdt_1": t("kp_1800_mdt_1"),
            "kp_1800_mdt_2": t("kp_1800_mdt_2"),
            "kp_1800_mdt_3": t("kp_1800_mdt_3"),
            "kp_1800_mdt_4": t("kp_1800_mdt_4"),
            "kp_1800_mdt_5": t("kp_1800_mdt_5"),
            "kp_1800_mdt_6": t("kp_1800_mdt_6"),
            "kp_1800_mdt_7": t("kp_1800_mdt_7")
        },
        "mbf": {
            "kp_1800_mbf_1": t("kp_1800_mbf_1"),
            "kp_1800_mbf_2": t("kp_1800_mbf_2"),
            "kp_1800_mbf_3": t("kp_1800_mbf_3"),
            "kp_1800_mbf_4": t("kp_1800_mbf_4"),
            "kp_1800_mbf_5": t("kp_1800_mbf_5"),
            "kp_1800_mbf_6": t("kp_1800_mbf_6"),
            "kp_1800_mbf_7": t("kp_1800_mbf_7")
        },
        "mmb": {
            "kp_1800_mmb_1": t("kp_1800_mmb_1"),
            "kp_1800_mmb_2": t("kp_1800_mmb_2"),
            "kp_1800_mmb_3": t("kp_1800_mmb_3"),
            "kp_1800_mmb_4": t("kp_1800_mmb_4"),
            "kp_1800_mmb_5": t("kp_1800_mmb_5"),
            "kp_1800_mmb_6": t("kp_1800_mmb_6"),
            "kp_1800_mmb_7": t("kp_1800_mmb_7")
        },
        "lunch": {
            "kp_1800_lunch_1": t("kp_1800_lunch_1"),
            "kp_1800_lunch_2": t("kp_1800_lunch_2"),
            "kp_1800_lunch_3": t("kp_1800_lunch_3"),
            "kp_1800_lunch_4": t("kp_1800_lunch_4"),
            "kp_1800_lunch_5": t("kp_1800_lunch_5"),
            "kp_1800_lunch_6": t("kp_1800_lunch_6"),
            "kp_1800_lunch_7": t("kp_1800_lunch_7")
        },
        "snack": {
            "kp_1800_snack_1": t("kp_1800_snack_1"),
            "kp_1800_snack_2": t("kp_1800_snack_2"),
            "kp_1800_snack_3": t("kp_1800_snack_3"),
            "kp_1800_snack_4": t("kp_1800_snack_4"),
            "kp_1800_snack_5": t("kp_1800_snack_5"),
            "kp_1800_snack_6": t("kp_1800_snack_6"),
            "kp_1800_snack_7": t("kp_1800_snack_7")
        },
        "dinner": {
            "kp_1800_dinner_1": t("kp_1800_dinner_1"),
            "kp_1800_dinner_2": t("kp_1800_dinner_2"),
            "kp_1800_dinner_3": t("kp_1800_dinner_3"),
            "kp_1800_dinner_4": t("kp_1800_dinner_4"),
            "kp_1800_dinner_5": t("kp_1800_dinner_5"),
            "kp_1800_dinner_6": t("kp_1800_dinner_6"),
            "kp_1800_dinner_7": t("kp_1800_dinner_7")
        }
    },
    "KaphaPitta_2000": {
        "mdt": {
            "kp_2000_mdt_1": t("kp_2000_mdt_1"),
            "kp_2000_mdt_2": t("kp_2000_mdt_2"),
            "kp_2000_mdt_3": t("kp_2000_mdt_3"),
            "kp_2000_mdt_4": t("kp_2000_mdt_4"),
            "kp_2000_mdt_5": t("kp_2000_mdt_5"),
            "kp_2000_mdt_6": t("kp_2000_mdt_6"),
            "kp_2000_mdt_7": t("kp_2000_mdt_7")
        },
        "mbf": {
            "kp_2000_mbf_1": t("kp_2000_mbf_1"),
            "kp_2000_mbf_2": t("kp_2000_mbf_2"),
            "kp_2000_mbf_3": t("kp_2000_mbf_3"),
            "kp_2000_mbf_4": t("kp_2000_mbf_4"),
            "kp_2000_mbf_5": t("kp_2000_mbf_5"),
            "kp_2000_mbf_6": t("kp_2000_mbf_6"),
            "kp_2000_mbf_7": t("kp_2000_mbf_7")
        },
        "mmb": {
            "kp_2000_mmb_1": t("kp_2000_mmb_1"),
            "kp_2000_mmb_2": t("kp_2000_mmb_2"),
            "kp_2000_mmb_3": t("kp_2000_mmb_3"),
            "kp_2000_mmb_4": t("kp_2000_mmb_4"),
            "kp_2000_mmb_5": t("kp_2000_mmb_5"),
            "kp_2000_mmb_6": t("kp_2000_mmb_6"),
            "kp_2000_mmb_7": t("kp_2000_mmb_7")
        },
        "lunch": {
            "kp_2000_lunch_1": t("kp_2000_lunch_1"),
            "kp_2000_lunch_2": t("kp_2000_lunch_2"),
            "kp_2000_lunch_3": t("kp_2000_lunch_3"),
            "kp_2000_lunch_4": t("kp_2000_lunch_4"),
            "kp_2000_lunch_5": t("kp_2000_lunch_5"),
            "kp_2000_lunch_6": t("kp_2000_lunch_6"),
            "kp_2000_lunch_7": t("kp_2000_lunch_7")
        },
        "snack": {
            "kp_2000_snack_1": t("kp_2000_snack_1"),
            "kp_2000_snack_2": t("kp_2000_snack_2"),
            "kp_2000_snack_3": t("kp_2000_snack_3"),
            "kp_2000_snack_4": t("kp_2000_snack_4"),
            "kp_2000_snack_5": t("kp_2000_snack_5"),
            "kp_2000_snack_6": t("kp_2000_snack_6"),
            "kp_2000_snack_7": t("kp_2000_snack_7")
        },
        "dinner": {
            "kp_2000_dinner_1": t("kp_2000_dinner_1"),
            "kp_2000_dinner_2": t("kp_2000_dinner_2"),
            "kp_2000_dinner_3": t("kp_2000_dinner_3"),
            "kp_2000_dinner_4": t("kp_2000_dinner_4"),
            "kp_2000_dinner_5": t("kp_2000_dinner_5"),
            "kp_2000_dinner_6": t("kp_2000_dinner_6"),
            "kp_2000_dinner_7": t("kp_2000_dinner_7")
        }
    },
    "KaphaPitta_2200": {
        "mdt": {
            "kp_2200_mdt_1": t("kp_2200_mdt_1"),
            "kp_2200_mdt_2": t("kp_2200_mdt_2"),
            "kp_2200_mdt_3": t("kp_2200_mdt_3"),
            "kp_2200_mdt_4": t("kp_2200_mdt_4"),
            "kp_2200_mdt_5": t("kp_2200_mdt_5"),
            "kp_2200_mdt_6": t("kp_2200_mdt_6"),
            "kp_2200_mdt_7": t("kp_2200_mdt_7")
        },
        "mbf": {
            "kp_2200_mbf_1": t("kp_2200_mbf_1"),
            "kp_2200_mbf_2": t("kp_2200_mbf_2"),
            "kp_2200_mbf_3": t("kp_2200_mbf_3"),
            "kp_2200_mbf_4": t("kp_2200_mbf_4"),
            "kp_2200_mbf_5": t("kp_2200_mbf_5"),
            "kp_2200_mbf_6": t("kp_2200_mbf_6"),
            "kp_2200_mbf_7": t("kp_2200_mbf_7")
        },
        "mmb": {
            "kp_2200_mmb_1": t("kp_2200_mmb_1"),
            "kp_2200_mmb_2": t("kp_2200_mmb_2"),
            "kp_2200_mmb_3": t("kp_2200_mmb_3"),
            "kp_2200_mmb_4": t("kp_2200_mmb_4"),
            "kp_2200_mmb_5": t("kp_2200_mmb_5"),
            "kp_2200_mmb_6": t("kp_2200_mmb_6"),
            "kp_2200_mmb_7": t("kp_2200_mmb_7")
        },
        "lunch": {
            "kp_2200_lunch_1": t("kp_2200_lunch_1"),
            "kp_2200_lunch_2": t("kp_2200_lunch_2"),
            "kp_2200_lunch_3": t("kp_2200_lunch_3"),
            "kp_2200_lunch_4": t("kp_2200_lunch_4"),
            "kp_2200_lunch_5": t("kp_2200_lunch_5"),
            "kp_2200_lunch_6": t("kp_2200_lunch_6"),
            "kp_2200_lunch_7": t("kp_2200_lunch_7")
        },
        "snack": {
            "kp_2200_snack_1": t("kp_2200_snack_1"),
            "kp_2200_snack_2": t("kp_2200_snack_2"),
            "kp_2200_snack_3": t("kp_2200_snack_3"),
            "kp_2200_snack_4": t("kp_2200_snack_4"),
            "kp_2200_snack_5": t("kp_2200_snack_5"),
            "kp_2200_snack_6": t("kp_2200_snack_6"),
            "kp_2200_snack_7": t("kp_2200_snack_7")
        },
        "dinner": {
            "kp_2200_dinner_1": t("kp_2200_dinner_1"),
            "kp_2200_dinner_2": t("kp_2200_dinner_2"),
            "kp_2200_dinner_3": t("kp_2200_dinner_3"),
            "kp_2200_dinner_4": t("kp_2200_dinner_4"),
            "kp_2200_dinner_5": t("kp_2200_dinner_5"),
            "kp_2200_dinner_6": t("kp_2200_dinner_6"),
            "kp_2200_dinner_7": t("kp_2200_dinner_7")
        }
    },
    "KaphaPitta_2400": {
        "mdt": {
            "kp_2400_mdt_1": t("kp_2400_mdt_1"),
            "kp_2400_mdt_2": t("kp_2400_mdt_2"),
            "kp_2400_mdt_3": t("kp_2400_mdt_3"),
            "kp_2400_mdt_4": t("kp_2400_mdt_4"),
            "kp_2400_mdt_5": t("kp_2400_mdt_5"),
            "kp_2400_mdt_6": t("kp_2400_mdt_6"),
            "kp_2400_mdt_7": t("kp_2400_mdt_7")
        },
        "mbf": {
            "kp_2400_mbf_1": t("kp_2400_mbf_1"),
            "kp_2400_mbf_2": t("kp_2400_mbf_2"),
            "kp_2400_mbf_3": t("kp_2400_mbf_3"),
            "kp_2400_mbf_4": t("kp_2400_mbf_4"),
            "kp_2400_mbf_5": t("kp_2400_mbf_5"),
            "kp_2400_mbf_6": t("kp_2400_mbf_6"),
            "kp_2400_mbf_7": t("kp_2400_mbf_7")
        },
        "mmb": {
            "kp_2400_mmb_1": t("kp_2400_mmb_1"),
            "kp_2400_mmb_2": t("kp_2400_mmb_2"),
            "kp_2400_mmb_3": t("kp_2400_mmb_3"),
            "kp_2400_mmb_4": t("kp_2400_mmb_4"),
            "kp_2400_mmb_5": t("kp_2400_mmb_5"),
            "kp_2400_mmb_6": t("kp_2400_mmb_6"),
            "kp_2400_mmb_7": t("kp_2400_mmb_7")
        },
        "lunch": {
            "kp_2400_lunch_1": t("kp_2400_lunch_1"),
            "kp_2400_lunch_2": t("kp_2400_lunch_2"),
            "kp_2400_lunch_3": t("kp_2400_lunch_3"),
            "kp_2400_lunch_4": t("kp_2400_lunch_4"),
            "kp_2400_lunch_5": t("kp_2400_lunch_5"),
            "kp_2400_lunch_6": t("kp_2400_lunch_6"),
            "kp_2400_lunch_7": t("kp_2400_lunch_7")
        },
        "snack": {
            "kp_2400_snack_1": t("kp_2400_snack_1"),
            "kp_2400_snack_2": t("kp_2400_snack_2"),
            "kp_2400_snack_3": t("kp_2400_snack_3"),
            "kp_2400_snack_4": t("kp_2400_snack_4"),
            "kp_2400_snack_5": t("kp_2400_snack_5"),
            "kp_2400_snack_6": t("kp_2400_snack_6"),
            "kp_2400_snack_7": t("kp_2400_snack_7")
        },
        "dinner": {
            "kp_2400_dinner_1": t("kp_2400_dinner_1"),
            "kp_2400_dinner_2": t("kp_2400_dinner_2"),
            "kp_2400_dinner_3": t("kp_2400_dinner_3"),
            "kp_2400_dinner_4": t("kp_2400_dinner_4"),
            "kp_2400_dinner_5": t("kp_2400_dinner_5"),
            "kp_2400_dinner_6": t("kp_2400_dinner_6"),
            "kp_2400_dinner_7": t("kp_2400_dinner_7")
        }
    },
    "KaphaPitta_2600": {
        "mdt": {
            "kp_2600_mdt_1": t("kp_2600_mdt_1"),
            "kp_2600_mdt_2": t("kp_2600_mdt_2"),
            "kp_2600_mdt_3": t("kp_2600_mdt_3"),
            "kp_2600_mdt_4": t("kp_2600_mdt_4"),
            "kp_2600_mdt_5": t("kp_2600_mdt_5"),
            "kp_2600_mdt_6": t("kp_2600_mdt_6"),
            "kp_2600_mdt_7": t("kp_2600_mdt_7")
        },
        "mbf": {
            "kp_2600_mbf_1": t("kp_2600_mbf_1"),
            "kp_2600_mbf_2": t("kp_2600_mbf_2"),
            "kp_2600_mbf_3": t("kp_2600_mbf_3"),
            "kp_2600_mbf_4": t("kp_2600_mbf_4"),
            "kp_2600_mbf_5": t("kp_2600_mbf_5"),
            "kp_2600_mbf_6": t("kp_2600_mbf_6"),
            "kp_2600_mbf_7": t("kp_2600_mbf_7")
        },
        "mmb": {
            "kp_2600_mmb_1": t("kp_2600_mmb_1"),
            "kp_2600_mmb_2": t("kp_2600_mmb_2"),
            "kp_2600_mmb_3": t("kp_2600_mmb_3"),
            "kp_2600_mmb_4": t("kp_2600_mmb_4"),
            "kp_2600_mmb_5": t("kp_2600_mmb_5"),
            "kp_2600_mmb_6": t("kp_2600_mmb_6"),
            "kp_2600_mmb_7": t("kp_2600_mmb_7")
        },
        "lunch": {
            "kp_2600_lunch_1": t("kp_2600_lunch_1"),
            "kp_2600_lunch_2": t("kp_2600_lunch_2"),
            "kp_2600_lunch_3": t("kp_2600_lunch_3"),
            "kp_2600_lunch_4": t("kp_2600_lunch_4"),
            "kp_2600_lunch_5": t("kp_2600_lunch_5"),
            "kp_2600_lunch_6": t("kp_2600_lunch_6"),
            "kp_2600_lunch_7": t("kp_2600_lunch_7")
        },
        "snack": {
            "kp_2600_snack_1": t("kp_2600_snack_1"),
            "kp_2600_snack_2": t("kp_2600_snack_2"),
            "kp_2600_snack_3": t("kp_2600_snack_3"),
            "kp_2600_snack_4": t("kp_2600_snack_4"),
            "kp_2600_snack_5": t("kp_2600_snack_5"),
            "kp_2600_snack_6": t("kp_2600_snack_6"),
            "kp_2600_snack_7": t("kp_2600_snack_7")
        },
        "dinner": {
            "kp_2600_dinner_1": t("kp_2600_dinner_1"),
            "kp_2600_dinner_2": t("kp_2600_dinner_2"),
            "kp_2600_dinner_3": t("kp_2600_dinner_3"),
            "kp_2600_dinner_4": t("kp_2600_dinner_4"),
            "kp_2600_dinner_5": t("kp_2600_dinner_5"),
            "kp_2600_dinner_6": t("kp_2600_dinner_6"),
            "kp_2600_dinner_7": t("kp_2600_dinner_7")
        }
    },
    "KaphaPitta_2800": {
        "mdt": {
            "kp_2800_mdt_1": t("kp_2800_mdt_1"),
            "kp_2800_mdt_2": t("kp_2800_mdt_2"),
            "kp_2800_mdt_3": t("kp_2800_mdt_3"),
            "kp_2800_mdt_4": t("kp_2800_mdt_4"),
            "kp_2800_mdt_5": t("kp_2800_mdt_5"),
            "kp_2800_mdt_6": t("kp_2800_mdt_6"),
            "kp_2800_mdt_7": t("kp_2800_mdt_7")
        },
        "mbf": {
            "kp_2800_mbf_1": t("kp_2800_mbf_1"),
            "kp_2800_mbf_2": t("kp_2800_mbf_2"),
            "kp_2800_mbf_3": t("kp_2800_mbf_3"),
            "kp_2800_mbf_4": t("kp_2800_mbf_4"),
            "kp_2800_mbf_5": t("kp_2800_mbf_5"),
            "kp_2800_mbf_6": t("kp_2800_mbf_6"),
            "kp_2800_mbf_7": t("kp_2800_mbf_7")
        },
        "mmb": {
            "kp_2800_mmb_1": t("kp_2800_mmb_1"),
            "kp_2800_mmb_2": t("kp_2800_mmb_2"),
            "kp_2800_mmb_3": t("kp_2800_mmb_3"),
            "kp_2800_mmb_4": t("kp_2800_mmb_4"),
            "kp_2800_mmb_5": t("kp_2800_mmb_5"),
            "kp_2800_mmb_6": t("kp_2800_mmb_6"),
            "kp_2800_mmb_7": t("kp_2800_mmb_7")
        },
        "lunch": {
            "kp_2800_lunch_1": t("kp_2800_lunch_1"),
            "kp_2800_lunch_2": t("kp_2800_lunch_2"),
            "kp_2800_lunch_3": t("kp_2800_lunch_3"),
            "kp_2800_lunch_4": t("kp_2800_lunch_4"),
            "kp_2800_lunch_5": t("kp_2800_lunch_5"),
            "kp_2800_lunch_6": t("kp_2800_lunch_6"),
            "kp_2800_lunch_7": t("kp_2800_lunch_7")
        },
        "snack": {
            "kp_2800_snack_1": t("kp_2800_snack_1"),
            "kp_2800_snack_2": t("kp_2800_snack_2"),
            "kp_2800_snack_3": t("kp_2800_snack_3"),
            "kp_2800_snack_4": t("kp_2800_snack_4"),
            "kp_2800_snack_5": t("kp_2800_snack_5"),
            "kp_2800_snack_6": t("kp_2800_snack_6"),
            "kp_2800_snack_7": t("kp_2800_snack_7")
        },
        "dinner": {
            "kp_2800_dinner_1": t("kp_2800_dinner_1"),
            "kp_2800_dinner_2": t("kp_2800_dinner_2"),
            "kp_2800_dinner_3": t("kp_2800_dinner_3"),
            "kp_2800_dinner_4": t("kp_2800_dinner_4"),
            "kp_2800_dinner_5": t("kp_2800_dinner_5"),
            "kp_2800_dinner_6": t("kp_2800_dinner_6"),
            "kp_2800_dinner_7": t("kp_2800_dinner_7")
        }
    },
    "KaphaPitta_3000": {
        "mdt": {
            "kp_3000_mdt_1": t("kp_3000_mdt_1"),
            "kp_3000_mdt_2": t("kp_3000_mdt_2"),
            "kp_3000_mdt_3": t("kp_3000_mdt_3"),
            "kp_3000_mdt_4": t("kp_3000_mdt_4"),
            "kp_3000_mdt_5": t("kp_3000_mdt_5"),
            "kp_3000_mdt_6": t("kp_3000_mdt_6"),
            "kp_3000_mdt_7": t("kp_3000_mdt_7")
        },
        "mbf": {
            "kp_3000_mbf_1": t("kp_3000_mbf_1"),
            "kp_3000_mbf_2": t("kp_3000_mbf_2"),
            "kp_3000_mbf_3": t("kp_3000_mbf_3"),
            "kp_3000_mbf_4": t("kp_3000_mbf_4"),
            "kp_3000_mbf_5": t("kp_3000_mbf_5"),
            "kp_3000_mbf_6": t("kp_3000_mbf_6"),
            "kp_3000_mbf_7": t("kp_3000_mbf_7")
        },
        "mmb": {
            "kp_3000_mmb_1": t("kp_3000_mmb_1"),
            "kp_3000_mmb_2": t("kp_3000_mmb_2"),
            "kp_3000_mmb_3": t("kp_3000_mmb_3"),
            "kp_3000_mmb_4": t("kp_3000_mmb_4"),
            "kp_3000_mmb_5": t("kp_3000_mmb_5"),
            "kp_3000_mmb_6": t("kp_3000_mmb_6"),
            "kp_3000_mmb_7": t("kp_3000_mmb_7")
        },
        "lunch": {
            "kp_3000_lunch_1": t("kp_3000_lunch_1"),
            "kp_3000_lunch_2": t("kp_3000_lunch_2"),
            "kp_3000_lunch_3": t("kp_3000_lunch_3"),
            "kp_3000_lunch_4": t("kp_3000_lunch_4"),
            "kp_3000_lunch_5": t("kp_3000_lunch_5"),
            "kp_3000_lunch_6": t("kp_3000_lunch_6"),
            "kp_3000_lunch_7": t("kp_3000_lunch_7")
        },
        "snack": {
            "kp_3000_snack_1": t("kp_3000_snack_1"),
            "kp_3000_snack_2": t("kp_3000_snack_2"),
            "kp_3000_snack_3": t("kp_3000_snack_3"),
            "kp_3000_snack_4": t("kp_3000_snack_4"),
            "kp_3000_snack_5": t("kp_3000_snack_5"),
            "kp_3000_snack_6": t("kp_3000_snack_6"),
            "kp_3000_snack_7": t("kp_3000_snack_7")
        },
        "dinner": {
            "kp_3000_dinner_1": t("kp_3000_dinner_1"),
            "kp_3000_dinner_2": t("kp_3000_dinner_2"),
            "kp_3000_dinner_3": t("kp_3000_dinner_3"),
            "kp_3000_dinner_4": t("kp_3000_dinner_4"),
            "kp_3000_dinner_5": t("kp_3000_dinner_5"),
            "kp_3000_dinner_6": t("kp_3000_dinner_6"),
            "kp_3000_dinner_7": t("kp_3000_dinner_7")
        }
    },

    // constant weight diet chart

    "VataPitta_const": {
        "mdt": {
            "vp_mdt_1": t("vp_mdt_1"),
            "vp_mdt_2": t("vp_mdt_2"),
            "vp_mdt_3": t("vp_mdt_3"),
            "vp_mdt_4": t("vp_mdt_4"),
            "vp_mdt_5": t("vp_mdt_5"),
            "vp_mdt_6": t("vp_mdt_6"),
            "vp_mdt_7": t("vp_mdt_7")
        },
        "mbf": {
            "vp_mbf_1": t("vp_mbf_1"),
            "vp_mbf_2": t("vp_mbf_2"),
            "vp_mbf_3": t("vp_mbf_3"),
            "vp_mbf_4": t("vp_mbf_4"),
            "vp_mbf_5": t("vp_mbf_5"),
            "vp_mbf_6": t("vp_mbf_6"),
            "vp_mbf_7": t("vp_mbf_7")
        },
        "mmb": {
            "vp_mmb_1": t("vp_mmb_1"),
            "vp_mmb_2": t("vp_mmb_2"),
            "vp_mmb_3": t("vp_mmb_3"),
            "vp_mmb_4": t("vp_mmb_4"),
            "vp_mmb_5": t("vp_mmb_5"),
            "vp_mmb_6": t("vp_mmb_6"),
            "vp_mmb_7": t("vp_mmb_7")
        },
        "lunch": {
            "vp_lunch_1": t("vp_lunch_1"),
            "vp_lunch_2": t("vp_lunch_2"),
            "vp_lunch_3": t("vp_lunch_3"),
            "vp_lunch_4": t("vp_lunch_4"),
            "vp_lunch_5": t("vp_lunch_5"),
            "vp_lunch_6": t("vp_lunch_6"),
            "vp_lunch_7": t("vp_lunch_7")
        },
        "snack": {
            "vp_snack_1": t("vp_snack_1"),
            "vp_snack_2": t("vp_snack_2"),
            "vp_snack_3": t("vp_snack_3"),
            "vp_snack_4": t("vp_snack_4"),
            "vp_snack_5": t("vp_snack_5"),
            "vp_snack_6": t("vp_snack_6"),
            "vp_snack_7": t("vp_snack_7")
        },
        "dinner": {
            "vp_dinner_1": t("vp_dinner_1"),
            "vp_dinner_2": t("vp_dinner_2"),
            "vp_dinner_3": t("vp_dinner_3"),
            "vp_dinner_4": t("vp_dinner_4"),
            "vp_dinner_5": t("vp_dinner_5"),
            "vp_dinner_6": t("vp_dinner_6"),
            "vp_dinner_7": t("vp_dinner_7")
        }
    },
    "VataKapha_const": {
        "mdt": {
            "vk_mdt_1": t("vk_mdt_1"),
            "vk_mdt_2": t("vk_mdt_2"),
            "vk_mdt_3": t("vk_mdt_3"),
            "vk_mdt_4": t("vk_mdt_4"),
            "vk_mdt_5": t("vk_mdt_5"),
            "vk_mdt_6": t("vk_mdt_6"),
            "vk_mdt_7": t("vk_mdt_7")
        },
        "mbf": {
            "vk_mbf_1": t("vk_mbf_1"),
            "vk_mbf_2": t("vk_mbf_2"),
            "vk_mbf_3": t("vk_mbf_3"),
            "vk_mbf_4": t("vk_mbf_4"),
            "vk_mbf_5": t("vk_mbf_5"),
            "vk_mbf_6": t("vk_mbf_6"),
            "vk_mbf_7": t("vk_mbf_7")
        },
        "mmb": {
            "vk_mmb_1": t("vk_mmb_1"),
            "vk_mmb_2": t("vk_mmb_2"),
            "vk_mmb_3": t("vk_mmb_3"),
            "vk_mmb_4": t("vk_mmb_4"),
            "vk_mmb_5": t("vk_mmb_5"),
            "vk_mmb_6": t("vk_mmb_6"),
            "vk_mmb_7": t("vk_mmb_7")
        },
        "lunch": {
            "vk_lunch_1": t("vk_lunch_1"),
            "vk_lunch_2": t("vk_lunch_2"),
            "vk_lunch_3": t("vk_lunch_3"),
            "vk_lunch_4": t("vk_lunch_4"),
            "vk_lunch_5": t("vk_lunch_5"),
            "vk_lunch_6": t("vk_lunch_6"),
            "vk_lunch_7": t("vk_lunch_7")
        },
        "snack": {
            "vk_snack_1": t("vk_snack_1"),
            "vk_snack_2": t("vk_snack_2"),
            "vk_snack_3": t("vk_snack_3"),
            "vk_snack_4": t("vk_snack_4"),
            "vk_snack_5": t("vk_snack_5"),
            "vk_snack_6": t("vk_snack_6"),
            "vk_snack_7": t("vk_snack_7")
        },
        "dinner": {
            "vk_dinner_1": t("vk_dinner_1"),
            "vk_dinner_2": t("vk_dinner_2"),
            "vk_dinner_3": t("vk_dinner_3"),
            "vk_dinner_4": t("vk_dinner_4"),
            "vk_dinner_5": t("vk_dinner_5"),
            "vk_dinner_6": t("vk_dinner_6"),
            "vk_dinner_7": t("vk_dinner_7")
        }
    },
    "PittaVata_const": {
        "mdt": {
            "pv_mdt_1": t("pv_mdt_1"),
            "pv_mdt_2": t("pv_mdt_2"),
            "pv_mdt_3": t("pv_mdt_3"),
            "pv_mdt_4": t("pv_mdt_4"),
            "pv_mdt_5": t("pv_mdt_5"),
            "pv_mdt_6": t("pv_mdt_6"),
            "pv_mdt_7": t("pv_mdt_7")
        },
        "mbf": {
            "pv_mbf_1": t("pv_mbf_1"),
            "pv_mbf_2": t("pv_mbf_2"),
            "pv_mbf_3": t("pv_mbf_3"),
            "pv_mbf_4": t("pv_mbf_4"),
            "pv_mbf_5": t("pv_mbf_5"),
            "pv_mbf_6": t("pv_mbf_6"),
            "pv_mbf_7": t("pv_mbf_7")
        },
        "mmb": {
            "pv_mmb_1": t("pv_mmb_1"),
            "pv_mmb_2": t("pv_mmb_2"),
            "pv_mmb_3": t("pv_mmb_3"),
            "pv_mmb_4": t("pv_mmb_4"),
            "pv_mmb_5": t("pv_mmb_5"),
            "pv_mmb_6": t("pv_mmb_6"),
            "pv_mmb_7": t("pv_mmb_7")
        },
        "lunch": {
            "pv_lunch_1": t("pv_lunch_1"),
            "pv_lunch_2": t("pv_lunch_2"),
            "pv_lunch_3": t("pv_lunch_3"),
            "pv_lunch_4": t("pv_lunch_4"),
            "pv_lunch_5": t("pv_lunch_5"),
            "pv_lunch_6": t("pv_lunch_6"),
            "pv_lunch_7": t("pv_lunch_7")
        },
        "snack": {
            "pv_snack_1": t("pv_snack_1"),
            "pv_snack_2": t("pv_snack_2"),
            "pv_snack_3": t("pv_snack_3"),
            "pv_snack_4": t("pv_snack_4"),
            "pv_snack_5": t("pv_snack_5"),
            "pv_snack_6": t("pv_snack_6"),
            "pv_snack_7": t("pv_snack_7")
        },
        "dinner": {
            "pv_dinner_1": t("pv_dinner_1"),
            "pv_dinner_2": t("pv_dinner_2"),
            "pv_dinner_3": t("pv_dinner_3"),
            "pv_dinner_4": t("pv_dinner_4"),
            "pv_dinner_5": t("pv_dinner_5"),
            "pv_dinner_6": t("pv_dinner_6"),
            "pv_dinner_7": t("pv_dinner_7")
        }
    },
    "PittaKapha_const": {
        "mdt": {
            "pk_mdt_1": t("pk_mdt_1"),
            "pk_mdt_2": t("pk_mdt_2"),
            "pk_mdt_3": t("pk_mdt_3"),
            "pk_mdt_4": t("pk_mdt_4"),
            "pk_mdt_5": t("pk_mdt_5"),
            "pk_mdt_6": t("pk_mdt_6"),
            "pk_mdt_7": t("pk_mdt_7")
        },
        "mbf": {
            "pk_mbf_1": t("pk_mbf_1"),
            "pk_mbf_2": t("pk_mbf_2"),
            "pk_mbf_3": t("pk_mbf_3"),
            "pk_mbf_4": t("pk_mbf_4"),
            "pk_mbf_5": t("pk_mbf_5"),
            "pk_mbf_6": t("pk_mbf_6"),
            "pk_mbf_7": t("pk_mbf_7")
        },
        "mmb": {
            "pk_mmb_1": t("pk_mmb_1"),
            "pk_mmb_2": t("pk_mmb_2"),
            "pk_mmb_3": t("pk_mmb_3"),
            "pk_mmb_4": t("pk_mmb_4"),
            "pk_mmb_5": t("pk_mmb_5"),
            "pk_mmb_6": t("pk_mmb_6"),
            "pk_mmb_7": t("pk_mmb_7")
        },
        "lunch": {
            "pk_lunch_1": t("pk_lunch_1"),
            "pk_lunch_2": t("pk_lunch_2"),
            "pk_lunch_3": t("pk_lunch_3"),
            "pk_lunch_4": t("pk_lunch_4"),
            "pk_lunch_5": t("pk_lunch_5"),
            "pk_lunch_6": t("pk_lunch_6"),
            "pk_lunch_7": t("pk_lunch_7")
        },
        "snack": {
            "pk_snack_1": t("pk_snack_1"),
            "pk_snack_2": t("pk_snack_2"),
            "pk_snack_3": t("pk_snack_3"),
            "pk_snack_4": t("pk_snack_4"),
            "pk_snack_5": t("pk_snack_5"),
            "pk_snack_6": t("pk_snack_6"),
            "pk_snack_7": t("pk_snack_7")
        },
        "dinner": {
            "pk_dinner_1": t("pk_dinner_1"),
            "pk_dinner_2": t("pk_dinner_2"),
            "pk_dinner_3": t("pk_dinner_3"),
            "pk_dinner_4": t("pk_dinner_4"),
            "pk_dinner_5": t("pk_dinner_5"),
            "pk_dinner_6": t("pk_dinner_6"),
            "pk_dinner_7": t("pk_dinner_7")
        }
    },
    "KaphaVata_const": {
        "mdt": {
            "kv_mdt_1": t("kv_mdt_1"),
            "kv_mdt_2": t("kv_mdt_2"),
            "kv_mdt_3": t("kv_mdt_3"),
            "kv_mdt_4": t("kv_mdt_4"),
            "kv_mdt_5": t("kv_mdt_5"),
            "kv_mdt_6": t("kv_mdt_6"),
            "kv_mdt_7": t("kv_mdt_7")
        },
        "mbf": {
            "kv_mbf_1": t("kv_mbf_1"),
            "kv_mbf_2": t("kv_mbf_2"),
            "kv_mbf_3": t("kv_mbf_3"),
            "kv_mbf_4": t("kv_mbf_4"),
            "kv_mbf_5": t("kv_mbf_5"),
            "kv_mbf_6": t("kv_mbf_6"),
            "kv_mbf_7": t("kv_mbf_7")
        },
        "mmb": {
            "kv_mmb_1": t("kv_mmb_1"),
            "kv_mmb_2": t("kv_mmb_2"),
            "kv_mmb_3": t("kv_mmb_3"),
            "kv_mmb_4": t("kv_mmb_4"),
            "kv_mmb_5": t("kv_mmb_5"),
            "kv_mmb_6": t("kv_mmb_6"),
            "kv_mmb_7": t("kv_mmb_7")
        },
        "lunch": {
            "kv_lunch_1": t("kv_lunch_1"),
            "kv_lunch_2": t("kv_lunch_2"),
            "kv_lunch_3": t("kv_lunch_3"),
            "kv_lunch_4": t("kv_lunch_4"),
            "kv_lunch_5": t("kv_lunch_5"),
            "kv_lunch_6": t("kv_lunch_6"),
            "kv_lunch_7": t("kv_lunch_7")
        },
        "snack": {
            "kv_snack_1": t("kv_snack_1"),
            "kv_snack_2": t("kv_snack_2"),
            "kv_snack_3": t("kv_snack_3"),
            "kv_snack_4": t("kv_snack_4"),
            "kv_snack_5": t("kv_snack_5"),
            "kv_snack_6": t("kv_snack_6"),
            "kv_snack_7": t("kv_snack_7")
        },
        "dinner": {
            "kv_dinner_1": t("kv_dinner_1"),
            "kv_dinner_2": t("kv_dinner_2"),
            "kv_dinner_3": t("kv_dinner_3"),
            "kv_dinner_4": t("kv_dinner_4"),
            "kv_dinner_5": t("kv_dinner_5"),
            "kv_dinner_6": t("kv_dinner_6"),
            "kv_dinner_7": t("kv_dinner_7")
        }
    },
    "KaphaPitta_const": {
        "mdt": {
            "kp_mdt_1": t("kp_mdt_1"),
            "kp_mdt_2": t("kp_mdt_2"),
            "kp_mdt_3": t("kp_mdt_3"),
            "kp_mdt_4": t("kp_mdt_4"),
            "kp_mdt_5": t("kp_mdt_5"),
            "kp_mdt_6": t("kp_mdt_6"),
            "kp_mdt_7": t("kp_mdt_7")
        },
        "mbf": {
            "kp_mbf_1": t("kp_mbf_1"),
            "kp_mbf_2": t("kp_mbf_2"),
            "kp_mbf_3": t("kp_mbf_3"),
            "kp_mbf_4": t("kp_mbf_4"),
            "kp_mbf_5": t("kp_mbf_5"),
            "kp_mbf_6": t("kp_mbf_6"),
            "kp_mbf_7": t("kp_mbf_7")
        },
        "mmb": {
            "kp_mmb_1": t("kp_mmb_1"),
            "kp_mmb_2": t("kp_mmb_2"),
            "kp_mmb_3": t("kp_mmb_3"),
            "kp_mmb_4": t("kp_mmb_4"),
            "kp_mmb_5": t("kp_mmb_5"),
            "kp_mmb_6": t("kp_mmb_6"),
            "kp_mmb_7": t("kp_mmb_7")
        },
        "lunch": {
            "kp_lunch_1": t("kp_lunch_1"),
            "kp_lunch_2": t("kp_lunch_2"),
            "kp_lunch_3": t("kp_lunch_3"),
            "kp_lunch_4": t("kp_lunch_4"),
            "kp_lunch_5": t("kp_lunch_5"),
            "kp_lunch_6": t("kp_lunch_6"),
            "kp_lunch_7": t("kp_lunch_7")
        },
        "snack": {
            "kp_snack_1": t("kp_snack_1"),
            "kp_snack_2": t("kp_snack_2"),
            "kp_snack_3": t("kp_snack_3"),
            "kp_snack_4": t("kp_snack_4"),
            "kp_snack_5": t("kp_snack_5"),
            "kp_snack_6": t("kp_snack_6"),
            "kp_snack_7": t("kp_snack_7")
        },
        "dinner": {
            "kp_dinner_1": t("kp_dinner_1"),
            "kp_dinner_2": t("kp_dinner_2"),
            "kp_dinner_3": t("kp_dinner_3"),
            "kp_dinner_4": t("kp_dinner_4"),
            "kp_dinner_5": t("kp_dinner_5"),
            "kp_dinner_6": t("kp_dinner_6"),
            "kp_dinner_7": t("kp_dinner_7")
        }
    }
});